var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedHatDisplayRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Fri Apr 22 03:06:47 2022\n By Aleksey,,,\nCopyright 2019 The Red Hat Project Authors (https://github.com/RedHatOfficial/RedHatFont)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "RedHatDisplay-Regular",
    horizAdvX: 1124
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Red Hat Display",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "2 1 5 3 4 2 1 6 3 3",
    ascent: 1638,
    descent: -410,
    xHeight: 1026,
    capHeight: 1434,
    bbox: "-137 -541 2167 2054",
    underlineThickness: 102,
    underlinePosition: -307,
    unicodeRange: "U+000D-FFFD"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1052,
    d: "M123 -205v1741h807v-1741h-807z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1052,
    d: "M123 -205v1741h807v-1741h-807z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    unicode: "\r",
    horizAdvX: 440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 405,
    d: "M141 397l-18 1071h158l-19 -1071h-121zM203 -12q-43 0 -74 30.5t-31 73.5t31 74t74 31t73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 651,
    d: "M141 1018l-22 418h153l-22 -418h-109zM403 1018l-22 418h154l-23 -418h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1417,
    d: "M162 0l129 449h-230v118h263l86 299h-246v119h278l129 449h140l-129 -449h405l129 449h139l-129 -449h230v-119h-262l-86 -299h245v-118h-278l-129 -449h-139l129 449h-406l-129 -449h-139zM463 567h405l86 299h-405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 1161,
    d: "M524 -154v197q-293 25 -479 229l94 101q163 -176 385 -207v504l-71 14q-206 44 -291.5 123t-85.5 225q0 162 125.5 263.5t322.5 101.5v157h105v-161q245 -28 444 -174l-78 -115q-186 131 -366 158v-474l69 -14q222 -50 312 -129t90 -225q0 -163 -130.5 -268t-340.5 -113 v-193h-105zM492 815l32 -6v461q-138 -1 -222.5 -63.5t-84.5 -162.5q0 -97 59 -146t216 -83zM659 643l-30 6v-487q143 8 234 77.5t91 174.5q0 96 -63 145t-232 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1513,
    d: "M360 707q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q134 0 218.5 -102.5t85.5 -266.5q-1 -164 -85.5 -266t-218.5 -102zM360 801q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145 -75t-55 -202q2 -127 55 -200.5t145 -73.5zM416 0h-125l805 1434h127z M1159 -10q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q133 0 217 -102.5t86 -266.5q-1 -164 -85 -266t-218 -102zM1159 84q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145.5 -75t-55.5 -202q2 -126 55.5 -200t145.5 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1337,
    d: "M1323 82l-92 -109q-118 89 -246 199q-183 -192 -459 -192q-214 0 -343.5 111t-129.5 294q0 125 64.5 215.5t214.5 173.5l39 23q-71 90 -101 163.5t-30 157.5q0 145 98.5 240.5t247.5 95.5q141 0 232 -82.5t91 -212.5q0 -100 -55.5 -180.5t-173.5 -149.5l-102 -61 q164 -181 389 -387q95 152 139 385l139 -23q-53 -269 -176 -454q139 -120 254 -207zM383 1120q0 -63 26 -121.5t89 -136.5l116 68q152 90 152 225q0 75 -53.5 125.5t-130.5 50.5q-87 0 -143 -59t-56 -152zM197 389q0 -127 92.5 -203.5t245.5 -76.5q209 0 350 153 q-257 232 -434 436l-48 -26q-111 -63 -158.5 -128.5t-47.5 -154.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 391,
    d: "M141 1018l-22 418h153l-22 -418h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 796,
    d: "M131 510q0 313 131 555.5t379 388.5l80 -102q-213 -124 -329 -343.5t-116 -498.5q0 -280 116 -499.5t329 -342.5l-80 -104q-248 148 -379 390.5t-131 555.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 796,
    d: "M666 520q0 -313 -131 -555.5t-379 -388.5l-80 102q213 124 328.5 343.5t115.5 498.5q0 280 -115.5 499.5t-328.5 342.5l80 104q248 -148 379 -390.5t131 -555.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 913,
    d: "M750 831l-242 150l4 -283h-111l5 283l-244 -150l-60 93l254 149l-245 148l59 90l233 -146l-2 269h111l-2 -267l231 144l62 -90l-246 -148l256 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 1075,
    d: "M602 297h-129v373h-360v127h360v364h129v-364h361v-127h-361v-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 405,
    d: "M156 152h163l-163 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 915,
    d: "M100 643h715v-135h-715v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 405,
    d: "M203 197q43 0 73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5t-74 30.5t-31 73.5t31 74t74 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 935,
    d: "M-137 -420l862 1854h154l-865 -1854h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 1353,
    d: "M676 -20q-170 0 -303 93t-207 261.5t-74 382.5t74.5 382.5t207.5 261.5t302 93q170 0 303.5 -93t208 -261.5t74.5 -382.5t-74.5 -382.5t-208 -261.5t-303.5 -93zM676 115q199 0 317.5 163.5t118.5 438.5q0 276 -118.5 440t-317.5 164q-198 0 -316 -164.5t-118 -439.5 t118 -438.5t316 -163.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 591,
    d: "M449 1434v-1434h-150v1276l-242 -107v138l295 127h97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 1110,
    d: "M76 0v111l542 522q144 141 196 225t52 180q0 123 -93 203t-234 80q-106 0 -197 -40.5t-201 -135.5l-88 104q231 203 488 203q207 0 340 -114t133 -291q0 -128 -60.5 -231t-236.5 -269l-436 -416h759v-131h-964z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 1191,
    d: "M1090 391q0 -179 -147 -295t-374 -116q-313 0 -524 202l100 99q93 -89 194.5 -129.5t229.5 -40.5q163 0 266 79t103 205q0 117 -101 190.5t-264 73.5h-120v125h112q136 0 227 80.5t91 200.5q0 110 -93 184t-231 74q-116 0 -207 -40t-188 -134l-101 100q213 207 500 207 q203 0 336 -110t133 -277q0 -109 -65 -197t-181 -135q138 -39 221 -131.5t83 -214.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 1267,
    d: "M1020 1434v-922h172v-129h-172v-383h-150v383h-815v119l805 932h160zM240 512h630v731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 1163,
    d: "M133 727l33 707h842v-131h-715l-21 -469q142 53 297 53q228 0 371 -122t143 -316q0 -211 -143.5 -340t-378.5 -129q-298 0 -510 194l94 100q99 -87 197.5 -126t220.5 -39q165 0 267 92t102 241q0 141 -108 230.5t-281 89.5q-159 0 -322 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 1253,
    d: "M672 -18q-255 0 -417.5 191t-162.5 493q0 358 183 573t483 215q194 0 344 -94l-74 -117q-133 76 -276 76q-232 0 -367.5 -166t-142.5 -461q80 96 196 150.5t240 54.5q215 0 355.5 -126.5t140.5 -321.5q0 -202 -142.5 -334.5t-359.5 -132.5zM651 772q-114 0 -219.5 -56 t-183.5 -157q25 -202 139.5 -324t282.5 -122q152 0 252 94t100 237q0 146 -103 237t-268 91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 1136,
    d: "M188 0l748 1300h-905v134h1075v-115l-746 -1319h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 1259,
    d: "M629 -20q-232 0 -383.5 115t-151.5 292q0 125 85 224.5t224 142.5q-115 43 -183 131.5t-68 197.5q0 160 136.5 266.5t340.5 106.5t341.5 -106.5t137.5 -266.5q0 -109 -68.5 -197.5t-183.5 -131.5q139 -43 224 -142.5t85 -224.5q0 -177 -151.5 -292t-384.5 -115zM629 819 q140 0 236 74.5t96 183.5t-95.5 184.5t-236.5 75.5q-139 0 -234.5 -75.5t-95.5 -184.5t95.5 -183.5t234.5 -74.5zM629 102q164 0 275.5 84.5t111.5 210.5q0 123 -111.5 207t-275.5 84t-275.5 -84t-111.5 -207q0 -126 111.5 -210.5t275.5 -84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 1253,
    d: "M582 1452q255 0 417 -191t162 -493q0 -358 -182.5 -573t-482.5 -215q-194 0 -344 94l73 116q132 -75 277 -75q232 0 367.5 166t142.5 460q-79 -95 -195.5 -149.5t-241.5 -54.5q-215 0 -355 126.5t-140 321.5q0 202 142.5 334.5t359.5 132.5zM602 662q114 0 220 55.5 t184 156.5q-25 202 -139.5 324.5t-282.5 122.5q-152 0 -252.5 -94.5t-100.5 -237.5q0 -146 103 -236.5t268 -90.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 405,
    d: "M203 197q43 0 73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5t-74 30.5t-31 73.5t31 74t74 31zM203 1049q43 0 73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5t-74 30.5t-31 73.5t31 74t74 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 411,
    d: "M219 1049q43 0 74 -31t31 -74t-31 -73.5t-74 -30.5t-73.5 30.5t-30.5 73.5t30.5 74t73.5 31zM141 152h164l-164 -433h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 1034,
    d: "M801 211l-651 504l651 502l76 -97l-535 -403l537 -408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 1081,
    d: "M963 627v-127h-850v127h850zM963 961v-127h-850v127h850z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 1034,
    d: "M233 1217l652 -504l-652 -502l-75 96l534 404l-536 407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 1036,
    d: "M715 743l-70 -49q-75 -53 -105.5 -122t-23.5 -171h-131q-8 140 30 227.5t138 159.5l90 64q89 65 125.5 119t36.5 123q0 93 -86 157t-211 64q-207 0 -348 -185l-119 78q89 117 211.5 179.5t263.5 62.5q188 0 313 -101t125 -253q0 -106 -51.5 -183t-187.5 -170zM451 197 q43 0 73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5t-74 30.5t-31 73.5t31 74t74 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1589,
    d: "M731 104q-126 0 -209.5 89t-83.5 221q0 151 100.5 256.5t245.5 105.5q127 0 207 -80l10 54h115l-80 -394q-15 -73 15.5 -113t99.5 -40q107 0 179.5 99t72.5 245q0 153 -77 277.5t-211.5 195t-299.5 70.5q-173 0 -316.5 -87t-226 -239t-82.5 -336q0 -180 82.5 -324.5 t229 -225.5t329.5 -81q193 0 349 84l37 -84q-182 -92 -392 -92q-155 0 -291.5 55t-234 150t-153.5 228.5t-56 285.5q0 159 56 299t152.5 240.5t231.5 158.5t289 58q190 0 346.5 -82.5t246 -227t89.5 -319.5q0 -189 -103.5 -313.5t-258.5 -124.5q-132 0 -191 84 q-107 -93 -217 -93zM551 422q0 -98 57 -159.5t148 -61.5q95 0 166 71q-7 48 4 95l43 217q-29 44 -78.5 69t-108.5 25q-95 0 -163 -75.5t-68 -180.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1345,
    d: "M158 1434h581q207 0 330 -100t123 -269q0 -109 -57.5 -191.5t-161.5 -125.5q130 -40 204 -131t74 -214q0 -184 -132.5 -293.5t-354.5 -109.5h-606v1434zM731 1296h-416v-487h416q140 0 222.5 66t82.5 178t-82.5 177.5t-222.5 65.5zM752 137q155 0 247.5 74t92.5 197 t-92.5 196.5t-247.5 73.5h-437v-541h437z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-108 -113 -254.5 -174.5t-308.5 -61.5q-154 0 -292 58t-237 156.5t-157 235.5t-58 290t58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214 t-76 -302t77 -302t212 -214t299 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1474,
    d: "M158 0v1434h473q161 0 301 -54t239.5 -148t156 -227.5t56.5 -287.5q0 -205 -96.5 -369t-268.5 -256t-388 -92h-473zM639 1290h-324v-1147h324q123 0 231.5 44t186.5 120.5t123 183t45 226.5q0 161 -77 292.5t-211 206t-298 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 1243,
    d: "M158 0v1434h1026v-140h-869v-512h570v-137h-570v-645h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1613,
    d: "M1528 686q0 -147 -54 -278.5t-146.5 -226t-222 -149.5t-274.5 -55q-153 0 -290 58t-236 157t-157 236t-58 289t57.5 289t156 235.5t235.5 156.5t290 58q166 0 314 -61.5t252 -173.5l-107 -109q-83 94 -205 146.5t-254 52.5q-162 0 -294.5 -78t-208.5 -214t-76 -302 t76 -302t208.5 -214t294.5 -78q217 0 368.5 137.5t170.5 349.5h-514v140h674v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1464,
    d: "M158 0v1434h157v-641h834v641h158v-1434h-158v651h-834v-651h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 1228,
    d: "M1100 541q0 -258 -147.5 -411t-397.5 -153q-185 0 -321 96t-199 271l143 59q110 -280 379 -280q175 0 280 114t105 306v891h158v-893z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1263,
    d: "M158 0v1434h157v-680l742 680h207l-779 -703l795 -731h-221l-744 688v-688h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 1236,
    d: "M158 0v1434h157v-1293h854v-141h-1011z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1734,
    d: "M866 102l-561 1149v-1251h-147v1434h221l489 -1018l488 1018h221v-1434h-150v1253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1484,
    d: "M158 1434h157l863 -1164v1164h149v-1434h-139l-881 1194v-1194h-149v1434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1325,
    d: "M158 0v1434h622q210 0 336.5 -113t126.5 -301t-127 -302t-336 -114h-465v-604h-157zM768 1292h-453v-551h453q146 0 231.5 74.5t85.5 202.5q0 127 -85 200.5t-232 73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1656,
    d: "M1567 717q0 -160 -62.5 -301.5t-173.5 -243.5l152 -182l-162 -23l-100 121q-179 -111 -392 -111q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1079 471l154 -184 q83 83 128.5 193.5t45.5 236.5q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293 80l-204 243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1320,
    d: "M158 0v1434h614q211 0 339 -113t128 -299q0 -140 -82 -242.5t-223 -142.5l321 -637h-174l-307 616h-459v-616h-157zM762 1292h-447v-542h447q145 0 232 74t87 198q0 123 -87 196.5t-232 73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-395.5 -119.5q-171 0 -326.5 68.5t-273.5 197.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1263,
    d: "M35 1292v142h1194v-142h-518v-1292h-158v1292h-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1390,
    d: "M596 0l-588 1434h170l518 -1287l527 1287h159l-596 -1434h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1806,
    d: "M541 0h-160l-309 1434h159l244 -1184l354 1184h154l354 -1180l246 1180h154l-310 -1434h-159l-363 1214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1306,
    d: "M190 0h-184l553 743l-518 691h192l420 -570l420 570h184l-512 -689l555 -745h-190l-459 625z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1308,
    d: "M575 0v584l-569 850h184l469 -711l467 711h179l-572 -856v-578h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1236,
    d: "M49 0v113l912 1181h-904v140h1110v-113l-915 -1182h932v-139h-1135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 710,
    d: "M633 -424h-516v1858h516v-123h-371v-1612h371v-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 946,
    d: "M1083 -420h-159l-863 1854h158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 710,
    d: "M78 1434h516v-1858h-516v123h371v1612h-371v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 1097,
    d: "M100 717l383 717h133l383 -717h-141l-309 583l-309 -583h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 987,
    d: "M989 -164v-117h-991v117h991z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 1062,
    d: "M535 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 1208,
    d: "M1126 514q0 -147 -68 -269t-187 -191.5t-263 -69.5q-186 0 -329 118v-102h-150v1434l152 34v-550q130 124 329 124q143 0 261.5 -69.5t186.5 -191t68 -267.5zM596 909q-96 0 -178.5 -37.5t-136.5 -105.5v-508q54 -66 137 -103.5t178 -37.5q163 0 272 113t109 282 t-110 283t-271 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-82 -78 -184.5 -120.5t-212.5 -42.5q-144 0 -264 70t-189 192.5t-69 269.5q0 223 151.5 378t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v508l151 34v-1468h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5 q-162 0 -271.5 -112.5t-109.5 -280.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 765,
    d: "M35 1026h241v195q0 151 82 231t236 80q81 0 137 -19v-135q-71 21 -127 21q-91 0 -134.5 -44t-43.5 -138v-191h305v-129h-305v-897h-150v897h-241v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1200,
    d: "M594 -8q-214 0 -363 152t-149 374q0 145 68 266t186.5 190.5t261.5 69.5q179 0 324 -120v102h149v-1051q0 -197 -114 -302t-328 -105q-223 0 -402 106l66 119q175 -94 330 -94q146 0 221.5 69.5t75.5 204.5v138q-140 -119 -326 -119zM231 518q0 -166 108.5 -279.5 t266.5 -113.5q98 0 179.5 36.5t134.5 104.5v504q-53 66 -135 102.5t-179 36.5q-160 0 -267.5 -112.5t-107.5 -278.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M129 0v1434l152 34v-563q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 409,
    d: "M205 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30zM281 1026v-1026h-152v1026h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 409,
    d: "M205 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30zM16 -426q-48 0 -94 12v127q33 -8 76 -8q70 0 100.5 32.5t30.5 106.5v1182h152v-1194q0 -124 -69.5 -191t-195.5 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1011,
    d: "M129 0v1434l152 34v-905l536 463h184l-563 -487l590 -539h-207l-540 492v-492h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 409,
    d: "M281 1468v-1468h-152v1434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1759,
    d: "M129 0v1026h152v-113q119 134 301 134q106 0 190.5 -50t132.5 -137q126 187 352 187q167 0 272 -110.5t105 -287.5v-649h-149v618q0 136 -71.5 215.5t-194.5 79.5q-173 0 -273 -168q10 -52 10 -96v-649h-149v618q0 136 -71 215.5t-193 79.5q-166 0 -262 -149v-764h-152z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1208,
    d: "M129 -420v1446h150v-111q133 127 331 127q143 0 261.5 -69.5t186.5 -191t68 -267.5q0 -147 -68 -269t-187 -191.5t-263 -69.5q-184 0 -327 118v-522h-152zM596 909q-96 0 -178.5 -37.5t-136.5 -105.5v-508q54 -66 137 -103.5t178 -37.5q163 0 272 113t109 282t-110 283 t-271 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 1208,
    d: "M598 -16q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q189 0 330 -116v100h149v-1446h-151v526q-134 -122 -330 -122zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 708,
    d: "M129 0v1026h152v-145q46 80 119.5 124t166.5 44q51 0 97 -15v-139q-56 18 -107 18q-95 0 -165.5 -54t-110.5 -157v-702h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -133 -119 -223t-296 -90q-127 0 -238.5 41t-193.5 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 747,
    d: "M256 229v668h-221v129h221v260l150 39v-299h309v-129h-309v-629q0 -83 36 -118t121 -35q84 0 150 26v-133q-77 -26 -181 -26q-134 0 -205 63t-71 184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 1050,
    d: "M455 0l-445 1026h168l350 -829l351 829h161l-442 -1026h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1439,
    d: "M465 0h-148l-288 1026h149l221 -819l256 819h136l253 -819l224 819h143l-291 -1026h-145l-254 821z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1005,
    d: "M10 0l404 528l-383 498h180l291 -385l291 385h174l-379 -496l405 -530h-180l-313 418l-318 -418h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 1044,
    d: "M369 -133l59 135l-418 1024h168l332 -842l358 842h164l-510 -1180q-66 -150 -146 -214t-202 -64q-58 0 -96 10v137q36 -8 86 -8q69 0 118.5 39t86.5 121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 948,
    d: "M63 0v119l619 772h-612v135h796v-117l-620 -774h626v-135h-809z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 782,
    d: "M512 182l-98 -245q-44 -106 -7.5 -177t136.5 -71q62 0 127 22l30 -114q-80 -31 -163 -31q-118 0 -194.5 55t-91 145t31.5 205l86 203q50 114 6 193t-156 79h-162v125h162q112 0 156 80.5t-6 194.5l-86 201q-45 116 -30.5 206.5t90.5 145.5t194 55q83 0 163 -31l-30 -114 q-65 22 -127 22q-100 0 -136.5 -71t7.5 -177l98 -245q44 -112 -2.5 -204.5t-159.5 -123.5q114 -34 160 -126.5t2 -201.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 561,
    d: "M211 -422v1856h139v-1856h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 782,
    d: "M270 838l99 245q44 106 7.5 177t-136.5 71q-62 0 -127 -22l-31 114q80 31 164 31q118 0 194.5 -55t91 -145t-31.5 -205l-86 -203q-50 -114 -6.5 -193.5t155.5 -79.5h162v-124h-162q-112 0 -155.5 -80.5t6.5 -194.5l86 -201q45 -116 30.5 -206.5t-90.5 -145.5t-194 -55 q-84 0 -164 31l31 114q65 -22 127 -22q100 0 136.5 71t-7.5 177l-99 245q-44 112 2.5 204.5t159.5 123.5q-114 34 -160 126.5t-2 201.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 1183,
    d: "M532 870l164 -82q90 -45 138 -45q126 0 153 187l115 -15q-17 -142 -85.5 -220.5t-174.5 -78.5q-81 0 -191 58l-164 82q-91 47 -137 47q-124 0 -151 -187l-117 15q19 143 86.5 221t173.5 78q81 0 190 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    unicode: "\xA0",
    horizAdvX: 440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 405,
    d: "M264 1044l19 -1071h-158l18 1071h121zM203 1454q43 0 73.5 -30.5t30.5 -73.5t-30.5 -74t-73.5 -31t-74 31t-31 74t31 73.5t74 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 1054,
    d: "M539 -225v211q-196 23 -326.5 172.5t-130.5 355.5q0 204 130.5 353.5t326.5 174.5v222h104v-220q102 -6 196.5 -47.5t166.5 -111.5l-97 -111q-116 119 -266 131v-784q149 12 264 127l94 -103q-155 -149 -358 -161v-209h-104zM231 514q0 -148 87 -256t221 -133v776 q-134 -25 -221 -133.5t-87 -253.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 1259,
    d: "M412 55q-39 8 -80 8q-72 0 -121 -33.5t-84 -105.5l-111 74q101 183 279 195q53 41 53 129q0 34 -51 317h-215v117h194q-36 201 -36 266q0 198 118 314t322 116q183 0 300.5 -90.5t158.5 -265.5l-131 -39q-31 129 -115 197.5t-213 68.5q-142 0 -218.5 -77.5t-76.5 -217.5 q0 -44 39 -272h430v-117h-410q48 -277 48 -297q0 -100 -54 -160l408 -82q52 -10 86 -10q126 0 192 123l113 -72q-107 -182 -301 -182q-56 0 -117 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A4",
    unicode: "\xA4",
    horizAdvX: 1394,
    d: "M174 131l-80 82l191 193q-111 143 -111 333q0 191 113 332l-193 195l82 84l193 -195q142 117 329 117q188 0 330 -117l193 195l79 -82l-194 -195q115 -144 115 -334q0 -188 -111 -331l193 -195l-82 -84l-193 193q-142 -117 -330 -117t-333 119zM698 340q157 0 265 116 t108 283t-108 282.5t-265 115.5t-265.5 -115.5t-108.5 -282.5q0 -168 108 -283.5t266 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 1312,
    d: "M193 430h382v154l-2 4h-380v106h309l-496 740h184l469 -711l467 711h179l-494 -740h307v-106h-379l-6 -10v-148h385v-104h-385v-326h-158v326h-382v104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A6",
    unicode: "\xA6",
    horizAdvX: 561,
    d: "M350 588h-139v846h139v-846zM211 -422v846h139v-846h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 1159,
    d: "M926 176q0 -126 -97 -202t-256 -76q-181 0 -366 98l59 108q180 -94 307 -94q99 0 156 43.5t57 118.5q0 59 -37 99.5t-118 66.5l-225 74q-156 51 -220.5 117.5t-64.5 177.5q0 96 57 164t156 96q-103 77 -103 207q0 126 97.5 203t257.5 77q174 0 366 -100l-61 -109 q-172 96 -307 96q-100 0 -156.5 -43t-56.5 -118q0 -60 37.5 -100t119.5 -66l224 -74q157 -51 221.5 -118t64.5 -179q0 -94 -57 -162t-158 -98q103 -78 103 -207zM674 457q12 -3 22 -8q97 11 153 60t56 124q0 65 -44 108.5t-142 75.5l-236 76q-13 3 -20 8 q-98 -10 -154.5 -59.5t-56.5 -124.5q0 -63 44 -107t142 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 1101,
    d: "M373 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29.5 -71.5t-70.5 -29.5zM731 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -72t-71.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1646,
    d: "M90 717q0 154 56.5 291t154 235t233.5 155.5t289 57.5q204 0 372 -97t264.5 -266.5t96.5 -375.5q0 -154 -56.5 -291.5t-154 -235.5t-233.5 -155.5t-289 -57.5t-289 57.5t-233.5 156t-154 235.5t-56.5 291zM1462 717q0 178 -85 328t-232 236.5t-322 86.5 q-174 0 -320 -86.5t-230.5 -236.5t-84.5 -328t84.5 -328t230.5 -236.5t320 -86.5q175 0 322 86.5t232 236.5t85 328zM475 717q0 159 107.5 269t263.5 110q82 0 157 -31t130 -88l-74 -82q-88 94 -211 94q-109 0 -182.5 -78t-73.5 -194q0 -115 74 -193t182 -78q118 0 209 91 l73 -80q-120 -117 -284 -117q-157 0 -264 109.5t-107 267.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 835,
    d: "M354 645q-127 0 -206.5 65t-79.5 169q0 109 84 172t229 63q119 0 219 -47v94q0 178 -199 178q-105 0 -241 -65l-47 96q166 78 303 78q149 0 229 -70.5t80 -201.5v-517h-125v72q-106 -86 -246 -86zM190 883q0 -63 52 -101.5t137 -38.5q132 0 221 80v146q-86 55 -215 55 q-89 0 -142 -38t-53 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 1224,
    d: "M705 1026l-467 -508l473 -518h-168l-480 514l480 512h162zM1130 1026l-466 -508l473 -518h-168l-480 514l480 512h161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AC",
    unicode: "\xAC",
    horizAdvX: 1120,
    d: "M100 643h920v-643h-135v508h-785v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 915,
    d: "M100 643h715v-135h-715v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1001,
    d: "M500 637q-172 0 -290 119.5t-118 292.5t118 292t290 119t290.5 -119t118.5 -292t-118.5 -292.5t-290.5 -119.5zM500 707q146 0 240 97t94 245t-94 245t-240 97q-143 0 -237.5 -97t-94.5 -245q0 -146 95 -244t237 -98zM365 858v385h151q62 0 96.5 -31t34.5 -86 q0 -35 -19.5 -64t-52.5 -44l95 -160h-76l-86 146h-74v-146h-69zM508 1186h-74v-129h72q34 0 53 17t19 48q0 64 -70 64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 1062,
    d: "M829 1380v-108h-579v108h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 794,
    d: "M399 868q-123 0 -209 86.5t-86 210.5q0 120 86 204.5t209 84.5q119 0 205 -85t86 -204q0 -123 -85.5 -210t-205.5 -87zM399 969q76 0 131.5 58.5t55.5 139.5q0 75 -56 131t-131 56q-78 0 -134 -55t-56 -132q0 -83 55 -140.5t135 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 1075,
    d: "M602 354h-129v363h-360v127h360v354h129v-354h361v-127h-361v-363zM963 123v-125h-850v125h850z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 595,
    d: "M53 717v78l279 256q59 58 82.5 95.5t23.5 78.5q0 56 -41.5 91.5t-105.5 35.5q-52 0 -96.5 -20t-100.5 -68l-59 71q121 109 258 109q109 0 179.5 -59.5t70.5 -151.5q0 -64 -31 -116.5t-113 -127.5l-198 -182h352v-90h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 641,
    d: "M584 913q0 -91 -77.5 -148.5t-197.5 -57.5q-166 0 -272 106l72 68q44 -44 90.5 -63t109.5 -19q75 0 120.5 33.5t45.5 89.5q0 49 -44 78.5t-116 29.5h-63v86h55q61 0 102.5 35t41.5 88q0 49 -41.5 81t-104.5 32q-56 0 -99 -20t-89 -66l-72 67q110 113 264 113 q108 0 178.5 -56.5t69.5 -142.5q1 -54 -30 -97.5t-87 -68.5q66 -21 105 -65t39 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 1062,
    d: "M535 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-147 0 -248 75v-475h-149v1446h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1333,
    d: "M651 0v592h-121q-201 0 -326.5 117t-125.5 303q0 189 125 305.5t325 116.5h648v-1434h-142v592h-243v-592h-140zM1034 721v584h-243v-584h243zM530 721h121v584h-121q-138 0 -222.5 -80t-84.5 -211q0 -133 84.5 -213t222.5 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 405,
    d: "M203 682q43 0 73.5 -30.5t30.5 -73.5t-30.5 -74t-73.5 -31t-74 31t-31 74t31 73.5t74 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 1062,
    d: "M805 -281q0 -82 -66.5 -134t-169.5 -52q-141 0 -231 84l61 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71t-103.5 26h-59l53 186h88l-31 -113q90 -5 142.5 -50t52.5 -118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 337,
    d: "M276 1434v-717h-106v606l-129 -53v92l168 72h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 950,
    d: "M74 1044q0 169 115.5 286.5t281.5 117.5q167 0 282 -117.5t115 -286.5q0 -168 -115 -284.5t-282 -116.5q-166 0 -281.5 117t-115.5 284zM745 1044q0 123 -78.5 207t-195.5 84q-114 0 -192 -84t-78 -207q0 -122 78 -205t192 -83q117 0 195.5 83t78.5 205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 1224,
    d: "M520 0l467 508l-473 518h168l479 -514l-479 -512h-162zM92 0l467 508l-473 518h168l479 -514l-479 -512h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1234,
    d: "M1114 717v-447h88v-90h-88v-180h-106v180h-406v86l393 451h119zM727 270h281v322zM276 1434v-717h-106v606l-129 -53v92l168 72h67zM203 0h-125l805 1434h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1304,
    d: "M276 1434v-717h-106v606l-129 -53v92l168 72h67zM203 0h-125l805 1434h127zM762 0v78l278 256q60 58 83.5 96t23.5 78q0 55 -41.5 91t-106.5 36q-52 0 -96 -20t-100 -68l-60 71q121 109 258 109q109 0 179.5 -59.5t70.5 -151.5q0 -64 -30.5 -116.5t-112.5 -127.5 l-199 -182h353v-90h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1427,
    d: "M584 913q0 -91 -77.5 -148.5t-197.5 -57.5q-166 0 -272 106l72 68q44 -44 90.5 -63t109.5 -19q75 0 120.5 33.5t45.5 89.5q0 49 -44 78.5t-116 29.5h-63v86h55q61 0 102.5 35t41.5 88q0 49 -41.5 81t-104.5 32q-56 0 -99 -20t-89 -66l-72 67q110 113 264 113 q108 0 178.5 -56.5t69.5 -142.5q1 -54 -30 -97.5t-87 -68.5q66 -21 105 -65t39 -103zM1307 717v-447h88v-90h-88v-180h-107v180h-405v86l393 451h119zM920 270h280v322zM395 0h-125l805 1434h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 1036,
    d: "M311 696l70 49q75 53 105.5 122t23.5 171h131q8 -140 -30 -227.5t-138 -159.5l-90 -63q-89 -65 -125.5 -119t-36.5 -123q0 -93 86 -157t211 -64q208 0 348 184l119 -78q-89 -117 -211.5 -179t-263.5 -62q-188 0 -313 101t-125 253q0 106 51.5 182.5t187.5 169.5z M575 1243q-43 0 -73.5 31t-30.5 74t30.5 73.5t73.5 30.5t74 -30.5t31 -73.5t-31 -74t-74 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM612 1874l189 -238h-133l-252 238h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM778 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM866 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM467 1624l-107 21q46 204 193 204q47 0 103 -28t107.5 -56t86.5 -28t56 26t36 90l105 -20q-43 -205 -193 -205q-46 0 -102 28t-108 56.5t-87 28.5q-37 0 -57.5 -27t-32.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM518 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71t-71 -29zM877 1657q-43 0 -72 28.5t-29 71.5q0 41 29 69.5t72 28.5 q44 0 72 -28t28 -70q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM696 1599q-96 0 -162.5 67t-66.5 163q0 95 66 160t163 65q95 0 161.5 -65.5t66.5 -159.5q0 -95 -67 -162.5t-161 -67.5zM696 1683q59 0 99.5 42.5t40.5 103.5q0 59 -41 100t-99 41 q-60 0 -100.5 -40.5t-40.5 -100.5q0 -63 40.5 -104.5t100.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1951,
    d: "M8 0l596 1434h1278v-140h-1026l203 -501h534v-138h-479l207 -516h561v-139h-672l-180 451h-676l-182 -451h-164zM410 586h565l-281 700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-101 -106 -238 -167.5t-289 -68.5l-24 -90q89 -5 141.5 -50t52.5 -118q0 -82 -66 -134t-169 -52q-142 0 -232 84l62 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71t-103.5 26h-60l47 166q-145 9 -273.5 70t-220.5 158.5 t-145 230t-53 278.5q0 153 58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214t-76 -302t77 -302t212 -214t299 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM614 1874l189 -238h-133l-252 238h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM778 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM868 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM518 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71t-71 -29zM877 1657q-43 0 -72 28.5t-29 71.5q0 41 29 69.5t72 28.5q44 0 72 -28t28 -70 q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM154 1874l188 -238h-133l-252 238h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM317 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM408 1628l-172 164l-170 -164h-123l213 248h163l213 -248h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM57 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t72 -28.5t29 -69.5q0 -42 -29.5 -71t-71.5 -29zM416 1657q-43 0 -72 28.5t-29 71.5q0 41 29 69.5t72 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1523,
    d: "M205 0v649h-178v135h178v650h473q215 0 387.5 -92t269.5 -256t97 -369t-96.5 -369t-269 -256t-388.5 -92h-473zM686 1290h-324v-506h388v-135h-388v-506h324q123 0 231.5 44t186.5 120.5t123 183t45 226.5q0 161 -77 292.5t-211 206t-298 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 1484,
    d: "M158 1434h157l863 -1164v1164h149v-1434h-139l-881 1194v-1194h-149v1434zM514 1624l-106 21q46 204 192 204q47 0 103 -28t107.5 -56t86.5 -28t56 26t36 90l105 -20q-43 -205 -193 -205q-46 0 -102 28t-108 56.5t-87 28.5q-37 0 -57.5 -27t-32.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM745 1874l189 -238h-133l-252 238h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM911 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM999 1628l-172 164l-170 -164h-122l213 248h163l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM600 1624l-106 21q46 204 192 204q47 0 103 -28t107.5 -56t86.5 -28t56 26t36 90l105 -20q-43 -205 -193 -205q-46 0 -102 28t-108 56.5t-87 28.5q-37 0 -57.5 -27t-32.5 -90z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM649 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t72 -28.5t29 -69.5q0 -42 -29.5 -71t-71.5 -29zM1008 1657q-43 0 -72 28.5t-29 71.5q0 41 29 69.5t72 28.5 q44 0 72 -28t28 -70q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 1114,
    d: "M238 332l-80 82l317 321l-317 322l82 84l317 -322l317 322l80 -82l-317 -322l319 -323l-82 -84l-319 323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1656,
    d: "M309 0h-162l158 190q-102 102 -158.5 238t-56.5 289t57.5 290t156 235.5t235.5 156t290 57.5q229 0 418 -127l86 105h166l-153 -185q105 -103 163 -240t58 -292q0 -204 -98 -374t-267.5 -268t-372.5 -98q-235 0 -428 134zM250 717q0 -242 153 -408l748 905 q-143 97 -322 97q-162 0 -294.5 -78t-208.5 -214t-76 -302zM1407 717q0 245 -158 413l-751 -905q149 -102 331 -102q161 0 293.5 78.5t208.5 214.5t76 301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM637 1874l188 -238h-133l-252 238h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM803 1874h194l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM891 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM543 1657q-43 0 -73 29t-30 71q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71t-71 -29zM901 1657 q-43 0 -71.5 28.5t-28.5 71.5q0 41 28.5 69.5t71.5 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1308,
    d: "M575 0v584l-569 850h184l469 -711l467 711h179l-572 -856v-578h-158zM737 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 1304,
    d: "M158 0v1434h157v-289h469q189 0 315 -122t126 -308q0 -182 -126 -303t-315 -121h-469v-291h-157zM768 1004h-453v-576h453q126 0 211.5 82t85.5 205q0 124 -85.5 207.5t-211.5 81.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1286,
    d: "M690 745q0 -40 28 -63.5t111 -52.5l158 -54q135 -47 194.5 -114t59.5 -172q0 -140 -103 -226t-270 -86q-232 0 -401 166l92 88q134 -137 307 -137q106 0 170 49t64 131q0 71 -38 113t-132 74l-164 53q-122 41 -172.5 89.5t-50.5 123.5q0 50 22 91t57 68.5t77.5 51.5 t84.5 47t77 48.5t57 61t22 79.5q0 90 -87 147t-224 57q-170 0 -260 -99.5t-90 -287.5v-991h-150v987q0 245 131 381.5t365 136.5q210 0 336 -87t126 -232q0 -60 -22 -109t-57 -81.5t-77.5 -59t-84.5 -47.5t-77 -41.5t-57 -46t-22 -56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM426 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM592 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM680 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM281 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l104 -21q-43 -204 -192 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM332 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71.5t-71 -29.5zM690 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70 q0 -43 -29 -72t-72 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM510 1192q-96 0 -162.5 66.5t-66.5 162.5q0 95 66 160.5t163 65.5q95 0 161 -66t66 -160q0 -95 -66.5 -162t-160.5 -67zM510 1276q59 0 99 42t40 103q0 59 -40.5 100.5t-98.5 41.5q-60 0 -100.5 -41 t-40.5 -101q0 -63 40.5 -104t100.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1857,
    d: "M453 -18q-169 0 -273 85.5t-104 223.5q0 143 112 228t301 85q165 0 295 -65v131q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q144 0 239.5 -51.5t135.5 -149.5q68 93 169 144.5t220 51.5q134 0 245.5 -70t176 -191.5t64.5 -266.5v-47h-842 q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69l94 -100q-170 -127 -383 -127q-129 0 -240 55t-182 151q-172 -206 -438 -206zM1286 909q-133 0 -229.5 -89.5t-118.5 -231.5h686q-20 138 -115.5 229.5t-222.5 91.5zM221 295q0 -86 72 -140.5t186 -54.5q210 0 357 181 q-29 67 -43 131q-121 82 -299 82q-123 0 -198 -55t-75 -144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-152 -146 -356 -161l-27 -97q90 -5 142.5 -50t52.5 -118q0 -82 -66 -134t-169 -52q-142 0 -232 84l62 66q78 -66 170 -66q61 0 96 27.5t35 72.5q0 44 -38 70.5t-104 26.5h-59l49 170q-204 19 -339.5 169t-135.5 361q0 223 151.5 378 t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM502 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM668 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM756 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM408 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71.5t-71 -29.5zM766 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -72t-71.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM121 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM285 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM375 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM25 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29.5 -71.5t-70.5 -29.5zM383 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -72t-71.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1230,
    d: "M539 1081l-64 95l178 110q-89 64 -219 100l62 111q162 -51 278 -137l225 141l64 -94l-199 -123q258 -252 258 -686q0 -280 -144.5 -449t-383.5 -169q-215 0 -362.5 151.5t-147.5 372.5q0 138 66 253t181 181t253 66q124 0 223.5 -58t159.5 -160q-44 257 -219 426z M598 117q154 0 259.5 109t105.5 270q0 159 -105.5 267.5t-259.5 108.5q-155 0 -261 -108t-106 -268q0 -161 106 -270t261 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152zM338 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l105 -21 q-43 -204 -193 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM522 1466l189 -237h-133l-252 237h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM688 1466h195l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM776 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM377 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l104 -21q-43 -204 -192 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM426 1249q-43 0 -72.5 29t-29.5 72q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71.5t-71 -29.5zM784 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70q0 -43 -29 -72t-72 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 1075,
    d: "M539 1012q-43 0 -74 30.5t-31 73.5t31 74t74 31t73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5zM113 670v127h850v-127h-850zM539 244q-43 0 -74 30.5t-31 73.5t31 74t74 31t73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 1210,
    d: "M109 0l118 141q-145 155 -145 373q0 147 69.5 269.5t190 193t264.5 70.5q160 0 297 -93l62 72h135l-117 -139q145 -155 145 -373q0 -148 -69.5 -271t-189.5 -193t-263 -70q-167 0 -301 94l-61 -74h-135zM231 514q0 -148 88 -260l496 592q-94 65 -209 65q-157 0 -266 -115 t-109 -282zM606 115q157 0 265 116t108 283q0 148 -88 260l-496 -592q92 -67 211 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM481 1466l189 -237h-133l-252 237h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM645 1466h195l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM735 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM385 1249q-43 0 -72.5 29t-29.5 72q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29.5 -71.5 t-70.5 -29.5zM743 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70q0 -43 -29 -72t-72 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 1044,
    d: "M369 -133l59 135l-418 1024h168l332 -842l358 842h164l-510 -1180q-66 -150 -146 -214t-202 -64q-58 0 -96 10v137q36 -8 86 -8q69 0 118.5 39t86.5 121zM594 1466h194l-253 -237h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1210,
    d: "M129 -420v1854l152 34v-550q130 124 329 124q143 0 261.5 -69.5t186.5 -191t68 -267.5q0 -147 -68 -269t-187 -191.5t-263 -69.5q-184 0 -327 118v-522h-152zM596 909q-96 0 -178.5 -37.5t-136.5 -105.5v-508q54 -66 137 -103.5t178 -37.5q163 0 272 113t109 282 t-110 283t-271 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 1044,
    d: "M369 -133l59 135l-418 1024h168l332 -842l358 842h164l-510 -1180q-66 -150 -146 -214t-202 -64q-58 0 -96 10v137q36 -8 86 -8q69 0 118.5 39t86.5 121zM334 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71.5t-71 -29.5zM692 1249 q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70q0 -43 -29 -72t-72 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM993 1788v-109h-579v109h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM807 1380v-108h-580v108h580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1434h-172l-180 451h-676l-182 -451h-164zM410 586h565l-281 700zM696 1720q78 0 132 45.5t77 132.5l107 -26q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l106 26q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h-148v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5 q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145zM510 1313q78 0 132 45.5t77 132.5l106 -27q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206 66.5t-109 185.5l106 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 1390,
    d: "M8 0l596 1434h191l587 -1432l2 -2q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -151 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5t155 138.5h-56l-180 451h-676l-182 -451h-164zM410 586h565l-281 700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 1056,
    d: "M453 -18q-169 0 -274 85.5t-105 223.5q0 145 110 229t299 84q166 0 301 -69v135q0 123 -69 185.5t-203 62.5q-144 0 -322 -91l-57 117q210 103 393 103q195 0 300.5 -92.5t105.5 -264.5v-690h2q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80 q-67 -43 -152 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5t155 138.5h-31v100q-136 -118 -331 -118zM219 295q0 -86 72.5 -140.5t187.5 -54.5q186 0 305 119v193q-121 82 -297 82q-123 0 -195.5 -54t-72.5 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-108 -113 -254.5 -174.5t-308.5 -61.5q-154 0 -292 58t-237 156.5t-157 235.5t-58 290t58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214 t-76 -302t77 -302t212 -214t299 -78zM907 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-82 -78 -184.5 -120.5t-212.5 -42.5q-144 0 -264 70t-189 192.5t-69 269.5q0 223 151.5 378t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z M684 1466h195l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-108 -113 -254.5 -174.5t-308.5 -61.5q-154 0 -292 58t-237 156.5t-157 235.5t-58 290t58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214 t-76 -302t77 -302t212 -214t299 -78zM997 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-82 -78 -184.5 -120.5t-212.5 -42.5q-144 0 -264 70t-189 192.5t-69 269.5q0 223 151.5 378t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z M772 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-108 -113 -254.5 -174.5t-308.5 -61.5q-154 0 -292 58t-237 156.5t-157 235.5t-58 290t58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214 t-76 -302t77 -302t212 -214t299 -78zM825 1640q-41 0 -70.5 30t-29.5 71t29.5 70.5t70.5 29.5q43 0 73 -29.5t30 -70.5t-30 -71t-73 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-82 -78 -184.5 -120.5t-212.5 -42.5q-144 0 -264 70t-189 192.5t-69 269.5q0 223 151.5 378t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z M602 1233q-41 0 -70.5 29.5t-29.5 70.5t29.5 71t70.5 30q43 0 73 -30t30 -71t-30 -70.5t-73 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 1478,
    d: "M838 123q133 0 253.5 52t202.5 144l103 -106q-108 -113 -254.5 -174.5t-308.5 -61.5q-154 0 -292 58t-237 156.5t-157 235.5t-58 290t58 290t157 235.5t237 156t292 57.5q167 0 315 -61t252 -174l-105 -111q-84 95 -206.5 148t-255.5 53q-163 0 -297.5 -78t-210.5 -214 t-76 -302t77 -302t212 -214t299 -78zM657 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 1050,
    d: "M608 119q167 0 299 129l94 -103q-82 -78 -184.5 -120.5t-212.5 -42.5q-144 0 -264 70t-189 192.5t-69 269.5q0 223 151.5 378t370.5 155q112 0 217 -42.5t185 -119.5l-97 -111q-61 64 -140 98.5t-163 34.5q-158 0 -266.5 -114t-108.5 -279q0 -167 109 -281t268 -114z M434 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 1474,
    d: "M158 0v1434h473q161 0 301 -54t239.5 -148t156 -227.5t56.5 -287.5q0 -205 -96.5 -369t-268.5 -256t-388 -92h-473zM639 1290h-324v-1147h324q123 0 231.5 44t186.5 120.5t123 183t45 226.5q0 161 -77 292.5t-211 206t-298 74.5zM569 1878l168 -162l168 162h127 l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 1325,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v508l151 34v-1468h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5 q-162 0 -271.5 -112.5t-109.5 -280.5zM1229 1462h160l-58 -422h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 1523,
    d: "M205 0v649h-178v135h178v650h473q215 0 387.5 -92t269.5 -256t97 -369t-96.5 -369t-269 -256t-388.5 -92h-473zM686 1290h-324v-506h388v-135h-388v-506h324q123 0 231.5 44t186.5 120.5t123 183t45 226.5q0 161 -77 292.5t-211 206t-298 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 1206,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v274h-336v119h336v115l151 34v-149h127v-119h-127v-1200h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508 q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5t-109.5 -280.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM995 1788v-109h-579v109h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM883 1380v-108h-580v108h580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM698 1720q78 0 132 45.5t77 132.5l107 -26q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l106 26q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM586 1313q78 0 132 45.5t77 132.5l106 -27q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206.5 66.5t-109.5 185.5l107 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM696 1640q-41 0 -70.5 30t-29.5 71t29.5 70.5t70.5 29.5q43 0 73 -29.5t30 -70.5t-30 -71t-73 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM586 1233q-41 0 -71 29.5t-30 70.5t30 71t71 30q42 0 72 -30t30 -71t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -152 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5t155 138.5h-915z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 1155,
    d: "M799 -410q-67 -43 -152 -43q-91 0 -146 48.5t-55 128.5q0 68 42.5 129.5t136.5 128.5h-15q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69l94 -100 q-115 -84 -227 -109q-111 -71 -163 -131.5t-52 -120.5q0 -51 31 -78.5t88 -27.5t98 28zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686q-20 138 -115.5 229.5t-222.5 91.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 1261,
    d: "M158 0v1434h1026v-140h-869v-501h568v-138h-568v-516h877v-139h-1034zM528 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 1155,
    d: "M993 109q-170 -127 -383 -127q-223 0 -375.5 153.5t-152.5 378.5q0 221 147 374.5t359 153.5q134 0 245.5 -70t175.5 -191.5t64 -266.5v-47h-842q17 -153 125 -252.5t260 -99.5q80 0 155.5 25t127.5 69zM584 909q-133 0 -229.5 -89.5t-118.5 -231.5h686 q-20 138 -115.5 229.5t-222.5 91.5zM418 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 1613,
    d: "M1528 686q0 -147 -54 -278.5t-146.5 -226t-222 -149.5t-274.5 -55q-153 0 -290 58t-236 157t-157 236t-58 289t57.5 289t156 235.5t235.5 156.5t290 58q166 0 314 -61.5t252 -173.5l-107 -109q-83 94 -205 146.5t-254 52.5q-162 0 -294.5 -78t-208.5 -214t-76 -302 t76 -302t208.5 -214t294.5 -78q217 0 368.5 137.5t170.5 349.5h-514v140h674v-64zM999 1628l-172 164l-170 -164h-122l213 248h163l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 1200,
    d: "M594 -8q-214 0 -363 152t-149 374q0 145 68 266t186.5 190.5t261.5 69.5q179 0 324 -120v102h149v-1051q0 -197 -114 -302t-328 -105q-223 0 -402 106l66 119q175 -94 330 -94q146 0 221.5 69.5t75.5 204.5v138q-140 -119 -326 -119zM231 518q0 -166 108.5 -279.5 t266.5 -113.5q98 0 179.5 36.5t134.5 104.5v504q-53 66 -135 102.5t-179 36.5q-160 0 -267.5 -112.5t-107.5 -278.5zM770 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 1613,
    d: "M1528 686q0 -147 -54 -278.5t-146.5 -226t-222 -149.5t-274.5 -55q-153 0 -290 58t-236 157t-157 236t-58 289t57.5 289t156 235.5t235.5 156.5t290 58q166 0 314 -61.5t252 -173.5l-107 -109q-83 94 -205 146.5t-254 52.5q-162 0 -294.5 -78t-208.5 -214t-76 -302 t76 -302t208.5 -214t294.5 -78q217 0 368.5 137.5t170.5 349.5h-514v140h674v-64zM829 1720q78 0 132 45.5t77 132.5l107 -26q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l107 26q43 -178 208 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 1200,
    d: "M594 -8q-214 0 -363 152t-149 374q0 145 68 266t186.5 190.5t261.5 69.5q179 0 324 -120v102h149v-1051q0 -197 -114 -302t-328 -105q-223 0 -402 106l66 119q175 -94 330 -94q146 0 221.5 69.5t75.5 204.5v138q-140 -119 -326 -119zM231 518q0 -166 108.5 -279.5 t266.5 -113.5q98 0 179.5 36.5t134.5 104.5v504q-53 66 -135 102.5t-179 36.5q-160 0 -267.5 -112.5t-107.5 -278.5zM600 1313q78 0 132 45.5t77 132.5l106 -27q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206 66.5t-109 185.5l106 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 1613,
    d: "M1528 686q0 -147 -54 -278.5t-146.5 -226t-222 -149.5t-274.5 -55q-153 0 -290 58t-236 157t-157 236t-58 289t57.5 289t156 235.5t235.5 156.5t290 58q166 0 314 -61.5t252 -173.5l-107 -109q-83 94 -205 146.5t-254 52.5q-162 0 -294.5 -78t-208.5 -214t-76 -302 t76 -302t208.5 -214t294.5 -78q217 0 368.5 137.5t170.5 349.5h-514v140h674v-64zM827 1640q-41 0 -70.5 30t-29.5 71t29.5 70.5t70.5 29.5q43 0 73 -29.5t30 -70.5t-30 -71t-73 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 1200,
    d: "M594 -8q-214 0 -363 152t-149 374q0 145 68 266t186.5 190.5t261.5 69.5q179 0 324 -120v102h149v-1051q0 -197 -114 -302t-328 -105q-223 0 -402 106l66 119q175 -94 330 -94q146 0 221.5 69.5t75.5 204.5v138q-140 -119 -326 -119zM231 518q0 -166 108.5 -279.5 t266.5 -113.5q98 0 179.5 36.5t134.5 104.5v504q-53 66 -135 102.5t-179 36.5q-160 0 -267.5 -112.5t-107.5 -278.5zM598 1233q-41 0 -70.5 29.5t-29.5 70.5t29.5 71t70.5 30q42 0 72 -30t30 -71t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 1613,
    d: "M1528 686q0 -147 -54 -278.5t-146.5 -226t-222 -149.5t-274.5 -55q-153 0 -290 58t-236 157t-157 236t-58 289t57.5 289t156 235.5t235.5 156.5t290 58q166 0 314 -61.5t252 -173.5l-107 -109q-83 94 -205 146.5t-254 52.5q-162 0 -294.5 -78t-208.5 -214t-76 -302 t76 -302t208.5 -214t294.5 -78q217 0 368.5 137.5t170.5 349.5h-514v140h674v-64zM762 -174h151l-122 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 1198,
    d: "M594 -8q-214 0 -363 152t-149 374q0 145 68 266t186.5 190.5t261.5 69.5q179 0 324 -120v102h149v-1051q0 -197 -114 -302t-328 -105q-223 0 -402 106l66 119q175 -94 330 -94q146 0 221.5 69.5t75.5 204.5v138q-140 -119 -326 -119zM231 518q0 -166 108.5 -279.5 t266.5 -113.5q98 0 179.5 36.5t134.5 104.5v504q-53 66 -135 102.5t-179 36.5q-160 0 -267.5 -112.5t-107.5 -278.5zM655 1245h-151l123 367h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 1464,
    d: "M158 0v1434h157v-641h834v641h158v-1434h-158v651h-834v-651h-157zM903 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    d: "M375 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125zM129 0v1434h152v-529q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 1488,
    d: "M170 0v1061h-139v135h139v238h158v-238h833v238h158v-238h139v-135h-139v-1061h-158v651h-833v-651h-158zM328 793h833v268h-833v-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    d: "M129 0v1200h-129v119h129v115l152 34v-149h333v-119h-333v-295q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM8 1624l-106 21q46 204 192 204q47 0 103 -28t107.5 -56t86.5 -28t56 26t36 90l105 -20q-43 -205 -193 -205q-46 0 -102 28t-108 56.5t-87 28.5q-37 0 -57.5 -27t-32.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM-25 1217l-106 20q46 205 192 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q36 0 57 26.5t36 90.5l104 -21q-43 -204 -193 -204q-46 0 -102 28t-107.5 56t-86.5 28q-37 0 -58 -26.5t-33 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM535 1788v-109h-580v109h580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM502 1380v-108h-580v108h580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM238 1720q78 0 131.5 45.5t76.5 132.5l107 -26q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206.5 66.5t-109.5 185.5l107 26q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 407,
    d: "M281 1026v-1026h-152v1026h152zM205 1313q78 0 132 45.5t77 132.5l106 -27q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206.5 66.5t-109.5 185.5l107 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -151 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5t155 138.5h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 409,
    d: "M205 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30zM281 0q-113 -71 -165.5 -131.5t-52.5 -120.5q0 -51 31 -78.5t88 -27.5q58 0 99 28l30 -80q-67 -43 -151 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5 t155 138.5h-33v1026h152v-1026z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 473,
    d: "M158 0v1434h157v-1434h-157zM236 1640q-41 0 -71 30t-30 71t30 70.5t71 29.5q43 0 72.5 -29.5t29.5 -70.5t-30 -71t-72 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 409,
    d: "M281 1026v-1026h-152v1026h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 1701,
    d: "M158 0v1434h157v-1434h-157zM1573 541q0 -258 -147.5 -411t-397.5 -153q-185 0 -321 96t-199 271l143 59q110 -280 379 -280q175 0 280 114t105 306v891h158v-893z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 811,
    d: "M205 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30zM281 1026v-1026h-152v1026h152zM610 1223q-41 0 -71.5 30.5t-30.5 71.5q0 42 30 72t72 30q43 0 73 -29.5t30 -72.5q0 -41 -30.5 -71.5t-72.5 -30.5zM422 -426 q-48 0 -94 12v127q33 -8 75 -8q70 0 101 32.5t31 106.5v1182h151v-1194q0 -124 -69 -191t-195 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 1228,
    d: "M1100 541q0 -258 -147.5 -411t-397.5 -153q-185 0 -321 96t-199 271l143 59q110 -280 379 -280q175 0 280 114t105 306v891h158v-893zM1194 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 407,
    d: "M-78 -414v127q36 -8 78 -8q69 0 99 32.5t30 106.5v1182h152v-1196q0 -122 -68 -189t-195 -67q-38 0 -96 12zM375 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 1263,
    d: "M158 0v1434h157v-680l742 680h207l-779 -703l795 -731h-221l-744 688v-688h-157zM602 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 1011,
    d: "M129 0v1434l152 34v-905l536 463h184l-563 -487l590 -539h-207l-540 492v-492h-152zM432 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 1011,
    d: "M129 0v1026h152v-463l536 463h184l-563 -487l590 -539h-207l-540 492v-492h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 1236,
    d: "M158 0v1434h157v-1293h854v-141h-1011zM317 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 409,
    d: "M287 1874h194l-254 -238h-133zM129 0v1434h152v-1434h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 1236,
    d: "M158 0v1434h157v-1293h854v-141h-1011zM627 -174h151l-123 -367h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 409,
    d: "M281 1468v-1468h-152v1434zM129 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 1226,
    d: "M158 0v1434h157v-1293h854v-141h-1011zM827 1462h160l-57 -422h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 524,
    d: "M281 1468v-1468h-152v1434zM428 1462h160l-58 -422h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 1226,
    d: "M158 0v1434h157v-1293h854v-141h-1011zM836 627q-41 0 -71 29.5t-30 70.5t30 70.5t71 29.5q43 0 72.5 -29.5t29.5 -70.5t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 604,
    d: "M281 1468v-1468h-152v1434zM510 621q-41 0 -70.5 29.5t-29.5 70.5t29.5 70.5t70.5 29.5q43 0 72.5 -29.5t29.5 -70.5t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 1255,
    d: "M186 0v475l-163 -125v152l163 125v807h158v-689l410 310v-152l-410 -309v-453h854v-141h-1012z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 491,
    d: "M18 672l154 125v637l152 34v-548l153 124v-153l-153 -125v-766h-152v645l-154 -125v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 1484,
    d: "M158 1434h157l863 -1164v1164h149v-1434h-139l-881 1194v-1194h-149v1434zM823 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152zM647 1466h195l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 1484,
    d: "M158 1434h157l863 -1164v1164h149v-1434h-139l-881 1194v-1194h-149v1434zM666 -174h151l-123 -367h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152zM489 -174h152l-123 -367h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 1484,
    d: "M158 1434h157l863 -1164v1164h149v-1434h-139l-881 1194v-1194h-149v1434zM573 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-649h-149v618q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152zM397 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 1484,
    d: "M1178 0l-871 1182v-1182h-149v1434h147l873 -1180v1180h149v-1604q0 -123 -68 -189.5t-194 -66.5q-50 0 -96 12v127q36 -8 78 -8q69 0 100 33t31 106v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    d: "M129 0v1026h152v-121q121 142 323 142q175 0 285 -110.5t110 -287.5v-819q0 -122 -67.5 -189t-194.5 -67q-38 0 -96 12v127q36 -8 80 -8q68 0 98.5 33t30.5 106v774q0 136 -77.5 215.5t-209.5 79.5q-186 0 -282 -157v-756h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM1126 1788v-109h-579v109h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM903 1380v-108h-579v108h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM829 1720q78 0 132 45.5t77 132.5l107 -26q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l107 26q43 -178 208 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM606 1313q78 0 132 45.5t77 132.5l107 -27q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l106 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 1656,
    d: "M1567 717q0 -204 -98 -374t-267.5 -268t-372.5 -98q-153 0 -290 58t-235.5 156.5t-156 235.5t-57.5 290t57.5 290t156 235.5t235.5 156t290 57.5q152 0 288.5 -57.5t235 -156t156.5 -235.5t58 -290zM1407 717q0 165 -76 301.5t-208.5 214.5t-293.5 78q-162 0 -294.5 -78 t-208.5 -214t-76 -302q0 -165 76 -301t209 -214.5t294 -78.5t293.5 78.5t208.5 214.5t76 301zM793 1874h176l-260 -232h-129zM1130 1874h179l-267 -232h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 1210,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 263 -70.5t189.5 -193t69.5 -269.5q0 -148 -69.5 -271t-189.5 -193t-263 -70q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5 t266.5 -115.5zM569 1466h176l-260 -231h-129zM907 1466h178l-266 -231h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 2222,
    d: "M807 0q-196 0 -360.5 95.5t-259.5 260.5t-95 361t95 361t259.5 260.5t360.5 95.5h1343v-140h-931q125 -83 203.5 -214.5t95.5 -286.5h370v-138h-368q-13 -159 -92 -294t-207 -222h929v-139h-1343zM807 143q154 0 281.5 75.5t200.5 207t73 291.5t-73 291.5t-200.5 206.5 t-281.5 75q-153 0 -280.5 -75t-201 -207t-73.5 -291t73.5 -291t201 -207.5t280.5 -75.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 2054,
    d: "M82 514q0 147 69.5 269.5t190 193t264.5 70.5q143 0 261.5 -71.5t185.5 -193.5q66 119 180.5 189.5t253.5 70.5q202 0 342.5 -153.5t140.5 -374.5v-47h-840q17 -153 125.5 -252.5t260.5 -99.5q167 0 282 94l94 -100q-170 -127 -383 -127q-147 0 -268 71t-188 193 q-67 -123 -185.5 -194.5t-261.5 -71.5q-220 0 -372 154.5t-152 379.5zM606 115q157 0 265 116t108 283t-108 282t-265 115t-266 -115t-109 -282q0 -168 108.5 -283.5t266.5 -115.5zM1481 909q-133 0 -228.5 -89.5t-117.5 -231.5h686q-22 138 -118 229.5t-222 91.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 1320,
    d: "M158 0v1434h614q211 0 339 -113t128 -299q0 -140 -82 -242.5t-223 -142.5l321 -637h-174l-307 616h-459v-616h-157zM762 1292h-447v-542h447q145 0 232 74t87 198q0 123 -87 196.5t-232 73.5zM731 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 708,
    d: "M129 0v1026h152v-145q46 80 119.5 124t166.5 44q51 0 97 -15v-139q-56 18 -107 18q-95 0 -165.5 -54t-110.5 -157v-702h-152zM453 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 1320,
    d: "M158 0v1434h614q211 0 339 -113t128 -299q0 -140 -82 -242.5t-223 -142.5l321 -637h-174l-307 616h-459v-616h-157zM762 1292h-447v-542h447q145 0 232 74t87 198q0 123 -87 196.5t-232 73.5zM578 -174h151l-123 -367h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 708,
    d: "M129 0v1026h152v-145q46 80 119.5 124t166.5 44q51 0 97 -15v-139q-56 18 -107 18q-95 0 -165.5 -54t-110.5 -157v-702h-152zM129 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 1320,
    d: "M158 0v1434h614q211 0 339 -113t128 -299q0 -140 -82 -242.5t-223 -142.5l321 -637h-174l-307 616h-459v-616h-157zM762 1292h-447v-542h447q145 0 232 74t87 198q0 123 -87 196.5t-232 73.5zM481 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 708,
    d: "M129 0v1026h152v-145q46 80 119.5 124t166.5 44q51 0 97 -15v-139q-56 18 -107 18q-95 0 -165.5 -54t-110.5 -157v-702h-152zM203 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-395.5 -119.5q-171 0 -326.5 68.5t-273.5 197.5zM657 1876h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -133 -119 -223t-296 -90q-127 0 -238.5 41t-193.5 118zM537 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-395.5 -119.5q-171 0 -326.5 68.5t-273.5 197.5zM745 1630l-172 164l-170 -164h-122l213 248h163l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -133 -119 -223t-296 -90q-127 0 -238.5 41t-193.5 118zM625 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-391.5 -119.5l-25 -89q90 -5 142.5 -49.5t52.5 -117.5q0 -82 -66.5 -134.5t-169.5 -52.5q-141 0 -231 84l61 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71t-103.5 26h-59l47 166q-149 15 -281.5 82 t-234.5 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -125 -105.5 -212.5t-266.5 -98.5l-27 -97q90 -5 142.5 -50t52.5 -118q0 -82 -66.5 -134t-169.5 -52q-141 0 -231 84l61 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71t-103.5 26h-60l50 170q-113 6 -213 47t-174 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-395.5 -119.5q-171 0 -326.5 68.5t-273.5 197.5zM408 1880l167 -162l168 162h127l-213 -246h-163l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -133 -119 -223t-296 -90q-127 0 -238.5 41t-193.5 118zM287 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 1263,
    d: "M35 1292v142h1194v-142h-518v-1292h-35l-31 -113q90 -5 142.5 -50t52.5 -118q0 -82 -66.5 -134t-169.5 -52q-141 0 -231 84l61 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71t-103.5 26h-59l53 186h-35v1292h-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 747,
    d: "M256 229v668h-221v129h221v260l150 39v-299h309v-129h-309v-629q0 -83 36 -118t121 -35q84 0 150 26v-133q-77 -26 -181 -26h-22l-27 -95q90 -5 142.5 -50t52.5 -118q0 -82 -66.5 -134t-169.5 -52q-141 0 -231 84l61 66q78 -66 170 -66q61 0 96 27.5t35 72.5t-37.5 71 t-103.5 26h-59l51 180q-168 48 -168 235z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 1263,
    d: "M35 1292v142h1194v-142h-518v-1292h-158v1292h-518zM463 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 751,
    d: "M575 1573l160 29l-51 -410h-121zM256 229v668h-221v129h221v260l150 39v-299h309v-129h-309v-629q0 -83 36 -118t121 -35q84 0 150 26v-133q-77 -26 -181 -26q-134 0 -205 63t-71 184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 1263,
    d: "M248 762h305v530h-518v142h1194v-142h-518v-530h305v-135h-305v-627h-158v627h-305v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 759,
    d: "M256 229v310h-221v120h221v238h-221v129h221v260l150 39v-299h309v-129h-309v-238h315v-120h-315v-271q0 -83 36 -118t121 -35q84 0 150 26v-133q-77 -26 -181 -26q-134 0 -205 63t-71 184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM492 1624l-107 21q46 204 193 204q47 0 103 -28t107 -56t86 -28q36 0 57 26t36 90l104 -20q-43 -205 -192 -205q-46 0 -102 28 t-108 56.5t-87 28.5q-37 0 -57.5 -27t-32.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM336 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l104 -21 q-43 -204 -192 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM1018 1788v-109h-580v109h580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM862 1380v-108h-579v108h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM721 1720q78 0 132 45.5t77 132.5l106 -26q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206 66.5t-109 185.5l106 26 q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM565 1313q78 0 132 45.5t77 132.5l107 -27q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5 l106 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM721 1599q-96 0 -162.5 67t-66.5 163q0 95 66 160t163 65q95 0 161 -65.5t66 -159.5q0 -95 -66.5 -162.5t-160.5 -67.5z M721 1683q59 0 99 42.5t40 103.5q0 59 -40.5 100t-98.5 41q-60 0 -100.5 -40.5t-40.5 -100.5q0 -63 40.5 -104.5t100.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM565 1192q-96 0 -162.5 66.5t-66.5 162.5q0 95 66 160.5t163 65.5q95 0 161.5 -66t66.5 -160q0 -95 -67 -162 t-161 -67zM565 1276q59 0 99.5 42t40.5 103q0 59 -41 100.5t-99 41.5q-60 0 -100.5 -41t-40.5 -101q0 -63 40.5 -104t100.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 1441,
    d: "M1313 606q0 -289 -160 -459t-432 -170q-274 0 -433 169.5t-159 459.5v828h158v-828q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828zM684 1874h176l-260 -232h-129zM1022 1874h178l-266 -232h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    d: "M274 1026v-618q0 -136 77.5 -215.5t209.5 -79.5q92 0 164.5 41t118.5 118v754h151v-1026h-151v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149zM526 1466h176l-260 -231h-129zM864 1466h178l-266 -231h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 1441,
    d: "M1313 606q0 -243 -115.5 -404.5t-318.5 -207.5q-108 -69 -158.5 -128.5t-50.5 -117.5q0 -51 30.5 -78.5t87.5 -27.5q58 0 99 28l31 -80q-67 -43 -152 -43q-91 0 -146 48.5t-55 128.5q0 66 40.5 125.5t131.5 127.5h-16q-274 0 -433 169.5t-159 459.5v828h158v-828 q0 -221 118 -352t316 -131t316 131t118 352v828h158v-828z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    d: "M997 0q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -151 -43q-91 0 -146 48.5t-55 128.5q0 72 48 137.5t155 138.5h-35v119q-121 -139 -322 -139q-177 0 -287 110t-110 287v649h149v-618q0 -136 77.5 -215.5t209.5 -79.5 q92 0 164.5 41t118.5 118v754h151v-1026h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1806,
    d: "M541 0h-160l-309 1434h159l244 -1184l354 1184h154l354 -1180l246 1180h154l-310 -1434h-159l-363 1214zM1073 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 1439,
    d: "M465 0h-148l-288 1026h149l221 -819l256 819h136l253 -819l224 819h143l-291 -1026h-145l-254 821zM891 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 1308,
    d: "M575 0v584l-569 850h184l469 -711l467 711h179l-572 -856v-578h-158zM827 1628l-172 164l-170 -164h-123l213 248h164l213 -248h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 1044,
    d: "M369 -133l59 135l-418 1024h168l332 -842l358 842h164l-510 -1180q-66 -150 -146 -214t-202 -64q-58 0 -96 10v137q36 -8 86 -8q69 0 118.5 39t86.5 121zM684 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 1308,
    d: "M575 0v584l-569 850h184l469 -711l467 711h179l-572 -856v-578h-158zM477 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t72 -28.5t29 -69.5q0 -42 -29.5 -71t-71.5 -29zM836 1657q-43 0 -72 28.5t-29 71.5q0 41 29 69.5t72 28.5q44 0 72 -28t28 -70 q0 -43 -28.5 -71.5t-71.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 1236,
    d: "M49 0v113l912 1181h-904v140h1110v-113l-915 -1182h932v-139h-1135zM713 1874h194l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 948,
    d: "M63 0v119l619 772h-612v135h796v-117l-620 -774h626v-135h-809zM549 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 1236,
    d: "M49 0v113l912 1181h-904v140h1110v-113l-915 -1182h932v-139h-1135zM631 1640q-41 0 -71 30t-30 71t30 70.5t71 29.5q43 0 72.5 -29.5t29.5 -70.5t-29.5 -71t-72.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 948,
    d: "M63 0v119l619 772h-612v135h796v-117l-620 -774h626v-135h-809zM467 1233q-41 0 -70.5 29.5t-29.5 70.5t29.5 71t70.5 30q43 0 72.5 -30t29.5 -71t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 1236,
    d: "M49 0v113l912 1181h-904v140h1110v-113l-915 -1182h932v-139h-1135zM463 1878l168 -162l168 162h127l-213 -246h-164l-213 246h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 948,
    d: "M63 0v119l619 772h-612v135h796v-117l-620 -774h626v-135h-809zM299 1470l168 -161l168 161h127l-213 -245h-164l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 1228,
    d: "M23 246l104 108q221 -237 502 -237q169 0 277 79t108 203q0 110 -76.5 169.5t-253.5 88.5l-207 33q-207 34 -305 122.5t-98 240.5q0 179 139 289t365 110q151 0 297.5 -49t267.5 -141l-90 -123q-236 178 -482 178q-154 0 -249 -69.5t-95 -182.5q0 -100 67 -153t224 -78 l205 -33q235 -38 341.5 -132t106.5 -261q0 -189 -152.5 -308.5t-395.5 -119.5q-171 0 -326.5 68.5t-273.5 197.5zM514 -170h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 913,
    d: "M25 141l92 99q147 -138 334 -138q123 0 200.5 51.5t77.5 133.5q0 66 -46 104t-144 51l-179 25q-154 23 -228.5 91t-74.5 185q0 129 108.5 214t276.5 85q218 0 404 -135l-80 -102q-170 115 -332 115q-105 0 -171 -47.5t-66 -122.5q0 -66 44.5 -101.5t145.5 -50.5l178 -25 q307 -43 307 -278q0 -133 -119 -223t-296 -90q-127 0 -238.5 41t-193.5 118zM383 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 1263,
    d: "M35 1292v142h1194v-142h-518v-1292h-158v1292h-518zM551 -174h151l-122 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 747,
    d: "M256 229v668h-221v129h221v260l150 39v-299h309v-129h-309v-629q0 -83 36 -118t121 -35q84 0 150 26v-133q-77 -26 -181 -26q-134 0 -205 63t-71 184zM395 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 409,
    d: "M-78 -414v127q36 -8 78 -8q69 0 99 32.5t30 106.5v1182h152v-1196q0 -122 -68 -189t-195 -67q-38 0 -96 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02BB",
    unicode: "\u02BB",
    horizAdvX: 405,
    d: "M223 1040h-164l164 433h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02BC",
    unicode: "\u02BC",
    horizAdvX: 405,
    d: "M209 1473h164l-164 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 1062,
    d: "M702 1221l-172 163l-170 -163h-122l213 247h163l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 1062,
    d: "M365 1470l167 -161l168 161h127l-213 -245h-163l-213 245h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 1062,
    d: "M532 1313q78 0 132 45.5t77 132.5l107 -27q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l107 27q43 -178 208 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 546,
    d: "M274 1233q-41 0 -70.5 29.5t-29.5 70.5t29.5 71t70.5 30q43 0 73 -30t30 -71t-30 -70.5t-73 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 1062,
    d: "M532 1192q-96 0 -162.5 66.5t-66.5 162.5q0 95 66 160.5t163 65.5q95 0 161.5 -66t66.5 -160q0 -95 -67 -162t-161 -67zM532 1276q59 0 99.5 42t40.5 103q0 59 -41 100.5t-99 41.5q-60 0 -100.5 -41t-40.5 -101q0 -63 40.5 -104t100.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 1062,
    d: "M651 0q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -152 -43q-91 0 -145.5 48.5t-54.5 128.5q0 79 59 150.5t193 158.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 1062,
    d: "M295 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l104 -21q-43 -204 -192 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 1081,
    d: "M469 1466h176l-260 -231h-129zM807 1466h178l-266 -231h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1806,
    d: "M541 0h-160l-309 1434h159l244 -1184l354 1184h154l354 -1180l246 1180h154l-310 -1434h-159l-363 1214zM825 1874l189 -238h-133l-252 238h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 1439,
    d: "M465 0h-148l-288 1026h149l221 -819l256 819h136l253 -819l224 819h143l-291 -1026h-145l-254 821zM637 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1806,
    d: "M541 0h-160l-309 1434h159l244 -1184l354 1184h154l354 -1180l246 1180h154l-310 -1434h-159l-363 1214zM989 1874h195l-254 -238h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 1439,
    d: "M465 0h-148l-288 1026h149l221 -819l256 819h136l253 -819l224 819h143l-291 -1026h-145l-254 821zM803 1466h194l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1806,
    d: "M541 0h-160l-309 1434h159l244 -1184l354 1184h154l354 -1180l246 1180h154l-310 -1434h-159l-363 1214zM725 1657q-43 0 -72.5 28.5t-29.5 71.5q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71t-71 -29zM1083 1657q-43 0 -71.5 28.5t-28.5 71.5 q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70q0 -43 -29 -71.5t-72 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 1439,
    d: "M465 0h-148l-288 1026h149l221 -819l256 819h136l253 -819l224 819h143l-291 -1026h-145l-254 821zM543 1249q-43 0 -73 29t-30 72q0 41 30 69.5t73 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29.5 -71.5t-70.5 -29.5zM901 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5 t71.5 28.5q44 0 72 -28t28 -70q0 -43 -28.5 -72t-71.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 1308,
    d: "M575 0v584l-569 850h184l469 -711l467 711h179l-572 -856v-578h-158zM573 1874l189 -238h-133l-252 238h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 1044,
    d: "M369 -133l59 135l-418 1024h168l332 -842l358 842h164l-510 -1180q-66 -150 -146 -214t-202 -64q-58 0 -96 10v137q36 -8 86 -8q69 0 118.5 39t86.5 121zM430 1466l188 -237h-133l-252 237h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2002",
    unicode: "\u2002",
    horizAdvX: 1024
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2003",
    unicode: "\u2003",
    horizAdvX: 2048
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2009",
    unicode: "\u2009",
    horizAdvX: 358
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni200A",
    unicode: "\u200A",
    horizAdvX: 204
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni200B",
    unicode: "\u200B",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 1120,
    d: "M100 643h920v-135h-920v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1427,
    d: "M100 643h1227v-135h-1227v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2015",
    unicode: "\u2015",
    horizAdvX: 1939,
    d: "M100 643h1739v-135h-1739v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 405,
    d: "M223 1040h-164l164 433h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 405,
    d: "M209 1473h164l-164 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 405,
    d: "M156 152h163l-163 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 681,
    d: "M223 1040h-164l164 433h119zM502 1040h-164l164 433h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 681,
    d: "M487 1473h164l-164 -433h-118zM209 1473h164l-164 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 681,
    d: "M434 152h164l-164 -433h-119zM156 152h163l-163 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 870,
    d: "M369 0v905h-258v123h258v406h135v-406h258v-123h-258v-905h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 870,
    d: "M369 0v406h-258v122h258v377h-258v123h258v406h135v-406h258v-123h-258v-377h258v-122h-258v-406h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 671,
    d: "M334 516q-85 0 -145 60t-60 145q0 86 60 147.5t145 61.5q86 0 147.5 -61.5t61.5 -147.5q0 -85 -61 -145t-148 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1202,
    d: "M203 197q43 0 73.5 -31t30.5 -74t-30.5 -73.5t-73.5 -30.5t-74 30.5t-31 73.5t31 74t74 31zM602 197q43 0 74 -31t31 -74t-31 -73.5t-74 -30.5t-73.5 30.5t-30.5 73.5t30.5 74t73.5 31zM999 197q43 0 74 -31t31 -74t-31 -73.5t-74 -30.5t-73.5 30.5t-30.5 73.5t30.5 74 t73.5 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 2220,
    d: "M360 707q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q134 0 218.5 -102.5t85.5 -266.5q-1 -164 -85.5 -266t-218.5 -102zM360 801q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145 -75t-55 -202q2 -127 55 -200.5t145 -73.5zM416 0h-125l805 1434h127z M1159 -10q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q133 0 217 -102.5t86 -266.5q-1 -164 -85 -266t-218 -102zM1159 84q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145.5 -75t-55.5 -202q2 -126 55.5 -200t145.5 -74zM1864 -10q-136 0 -220.5 102 t-84.5 266t84.5 266.5t220.5 102.5q133 0 217 -102.5t86 -266.5q-1 -164 -85 -266t-218 -102zM1864 84q91 0 144.5 74t53.5 200t-53.5 201.5t-144.5 75.5q-92 0 -145.5 -75t-55.5 -202q2 -126 55.5 -200t145.5 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2032",
    unicode: "\u2032",
    horizAdvX: 405,
    d: "M209 1473h164l-164 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2033",
    unicode: "\u2033",
    horizAdvX: 681,
    d: "M487 1473h164l-164 -433h-118zM209 1473h164l-164 -433h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 796,
    d: "M705 1026l-467 -508l473 -518h-168l-480 514l480 512h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 796,
    d: "M92 0l467 508l-473 518h168l479 -514l-479 -512h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 1183,
    d: "M186 0h-125l805 1434h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2070",
    unicode: "\u2070",
    horizAdvX: 716,
    d: "M360 707q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q134 0 218.5 -102.5t85.5 -266.5q-1 -164 -85.5 -266t-218.5 -102zM360 801q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145 -75t-55 -202q2 -127 55 -200.5t145 -73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    horizAdvX: 675,
    d: "M555 1434v-447h88v-90h-88v-180h-106v180h-406v86l393 451h119zM168 987h281v322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2075",
    unicode: "\u2075",
    horizAdvX: 632,
    d: "M82 1071l16 363h443v-93h-357l-8 -202q68 26 141 26q119 0 192 -61.5t73 -161.5q0 -105 -78 -170t-203 -65q-153 0 -260 96l65 74q88 -80 199 -80q75 0 121.5 39.5t46.5 103.5q0 60 -50 99.5t-126 39.5q-79 0 -150 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2076",
    unicode: "\u2076",
    horizAdvX: 667,
    d: "M358 707q-135 0 -219 96.5t-84 251.5q0 175 95 281t253 106q47 0 98.5 -16t88.5 -42l-58 -79q-61 43 -139 43q-105 0 -165 -72t-66 -205q39 43 94 68.5t113 25.5q109 0 179 -63t70 -160q0 -101 -74 -168t-186 -67zM350 1079q-107 0 -182 -94q13 -86 63.5 -136t124.5 -50 q68 0 112 40t44 101q0 62 -45 100.5t-117 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2077",
    unicode: "\u2077",
    horizAdvX: 610,
    d: "M115 717l352 624h-434v93h555v-80l-348 -637h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2078",
    unicode: "\u2078",
    horizAdvX: 669,
    d: "M336 707q-123 0 -201 57.5t-78 148.5q0 59 38 107t102 70q-52 24 -82.5 66.5t-30.5 94.5q0 83 71.5 139t178.5 56t179.5 -56t72.5 -139q0 -52 -30.5 -94.5t-82.5 -66.5q62 -22 99.5 -70t37.5 -107q0 -91 -77 -148.5t-197 -57.5zM336 1133q62 0 102.5 31.5t40.5 80.5 t-40.5 82t-102.5 33q-63 0 -105.5 -33t-42.5 -82t42 -80.5t106 -31.5zM336 795q72 0 121 35.5t49 89.5q0 55 -48.5 91t-121.5 36q-75 0 -123.5 -36t-48.5 -91q0 -54 48.5 -89.5t123.5 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2079",
    unicode: "\u2079",
    horizAdvX: 667,
    d: "M309 1442q135 0 219 -96.5t84 -251.5q0 -175 -95 -281t-253 -106q-48 0 -99 15.5t-87 41.5l57 80q61 -43 139 -43q106 0 166 72t66 204q-39 -43 -94 -68.5t-113 -25.5q-109 0 -179.5 63t-70.5 160q0 101 74 168.5t186 67.5zM317 1069q108 0 183 94q-13 86 -64 136.5 t-125 50.5q-67 0 -111 -40t-44 -102t44.5 -100.5t116.5 -38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 716,
    d: "M360 -10q-136 0 -220.5 102t-84.5 266t84.5 266.5t220.5 102.5q134 0 218.5 -102.5t85.5 -266.5q-1 -164 -85.5 -266t-218.5 -102zM360 84q91 0 145 74t54 200t-54 201.5t-145 75.5q-92 0 -145 -75t-55 -202q2 -127 55 -200.5t145 -73.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 337,
    d: "M276 717v-717h-106v606l-129 -53v92l168 72h67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 595,
    d: "M53 0v78l279 256q59 58 82.5 95.5t23.5 78.5q0 56 -41.5 91.5t-105.5 35.5q-52 0 -96.5 -20t-100.5 -68l-59 71q121 109 258 109q109 0 179.5 -59.5t70.5 -151.5q0 -64 -31 -116.5t-113 -127.5l-198 -182h352v-90h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 641,
    d: "M584 197q0 -91 -77.5 -149t-197.5 -58q-166 0 -272 106l72 68q44 -44 90.5 -63t109.5 -19q75 0 120.5 33.5t45.5 89.5q0 49 -44 78.5t-116 29.5h-63v86h55q61 0 102.5 35t41.5 88q0 49 -41.5 81t-104.5 32q-56 0 -99 -20t-89 -66l-72 67q110 113 264 113 q108 0 178.5 -56.5t69.5 -142.5q1 -53 -30 -96.5t-87 -68.5q66 -21 105 -65t39 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 675,
    d: "M555 717v-447h88v-90h-88v-180h-106v180h-406v86l393 451h119zM168 270h281v322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 632,
    d: "M82 354l16 363h443v-92h-357l-8 -203q70 27 141 27q118 0 191.5 -62t73.5 -162q0 -105 -78 -170t-203 -65q-153 0 -260 96l65 74q88 -80 199 -80q75 0 121.5 39.5t46.5 103.5q0 60 -50 99.5t-126 39.5q-79 0 -150 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 667,
    d: "M358 -10q-135 0 -219 96.5t-84 251.5q0 175 95 281t253 106q48 0 99.5 -15.5t87.5 -41.5l-58 -80q-61 43 -139 43q-105 0 -165 -72t-66 -205q39 43 94 69t113 26q108 0 178.5 -63.5t70.5 -160.5q0 -101 -74 -168t-186 -67zM350 362q-107 0 -182 -94q13 -86 63.5 -136 t124.5 -50q68 0 112 40t44 101q0 62 -45 100.5t-117 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 610,
    d: "M115 0l352 625h-434v92h555v-80l-348 -637h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 669,
    d: "M336 -10q-123 0 -201 58t-78 149q0 59 38 106.5t102 69.5q-52 24 -82.5 67t-30.5 95q0 83 71.5 138.5t178.5 55.5t179.5 -55.5t72.5 -138.5q0 -52 -30.5 -95t-82.5 -67q62 -22 99.5 -69.5t37.5 -106.5q0 -91 -77 -149t-197 -58zM336 416q62 0 102.5 31.5t40.5 80.5 t-40.5 82t-102.5 33q-63 0 -105.5 -33t-42.5 -82t42 -80.5t106 -31.5zM336 78q72 0 121 35.5t49 89.5q0 55 -48.5 91t-121.5 36q-75 0 -123.5 -36t-48.5 -91q0 -54 48.5 -89.5t123.5 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 667,
    d: "M309 725q135 0 219 -96.5t84 -251.5q0 -175 -95 -281t-253 -106q-48 0 -99 15.5t-87 41.5l57 80q61 -43 139 -43q106 0 166 72t66 204q-39 -43 -94 -68.5t-113 -25.5q-109 0 -179.5 63t-70.5 160q0 101 74 168.5t186 67.5zM317 352q108 0 183 94q-13 86 -64 136.5 t-125 50.5q-68 0 -111.5 -40t-43.5 -101q0 -62 44.5 -101t116.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 1587,
    d: "M406 717q0 -28 4 -82h501l-37 -105h-446q46 -193 184.5 -306t335.5 -113q134 0 249 54.5t187 153.5l105 -81q-94 -125 -235 -193t-306 -68q-255 0 -436.5 151t-235.5 402h-208v105h194q-4 54 -4 82q0 30 4 88h-194v102h211q54 249 237 399t438 150q171 0 309.5 -65 t231.5 -191l-109 -84q-75 102 -187 155.5t-249 53.5q-197 0 -335.5 -112.5t-186.5 -305.5h580l-37 -102h-561q-4 -58 -4 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1382,
    d: "M664 1434h112l180 -371l181 371h112v-572h-86l4 461l-211 -422l-208 416l2 -455h-86v572zM68 1434h493v-78h-203v-494h-88v494h-202v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2191",
    unicode: "\u2191",
    horizAdvX: 1034,
    d: "M442 0v1247l-333 -440l-99 78l504 651l502 -651l-96 -76l-338 448v-1257h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2193",
    unicode: "\u2193",
    horizAdvX: 1034,
    d: "M584 1434v-1248l334 441l98 -78l-504 -651l-502 651l96 76l338 -449v1258h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 1075,
    d: "M963 797v-127h-850v127h850z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 1183,
    d: "M186 0h-125l805 1434h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 1079,
    d: "M111 272l180 232h-178v123h274l160 207h-434v122h530l178 230h144l-179 -230h177v-122h-273l-160 -207h433v-123h-529l-180 -232h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "\uFB01",
    horizAdvX: 1173,
    d: "M35 1026h241v195q0 151 82 231t236 80q81 0 137 -19v-135q-71 21 -127 21q-91 0 -134.5 -44t-43.5 -138v-191h305v-129h-305v-897h-150v897h-241v129zM971 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30z M1047 1026v-1026h-152v1026h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "\uFB02",
    horizAdvX: 1173,
    d: "M35 1026h241v195q0 151 82 231t236 80q81 0 137 -19v-135q-71 21 -127 21q-91 0 -134.5 -44t-43.5 -138v-191h305v-129h-305v-897h-150v897h-241v129zM1047 1468v-1468h-152v1434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFEFF",
    unicode: "\uFEFF",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFFFD",
    unicode: "\uFFFD",
    horizAdvX: 2027,
    d: "M1014 -297l-1014 1014l1014 1014l1014 -1014zM1208 696q109 74 151 134.5t42 146.5q0 126 -107 210.5t-268 84.5q-143 0 -254 -71t-154 -189l201 -76q23 60 77 94.5t122 34.5q62 0 101.5 -29t39.5 -75q0 -51 -78 -105l-82 -61q-72 -56 -96 -115t-18 -166h207q-1 57 16 91 t61 65zM989 449q-60 0 -101.5 -42.5t-41.5 -101.5t41.5 -101t101.5 -42q58 0 99.5 42t41.5 101t-41.5 101.5t-99.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotaccent",
    horizAdvX: 405,
    d: "M205 1223q-41 0 -72 30.5t-31 71.5q0 42 30.5 72t72.5 30q43 0 72.5 -29.5t29.5 -72.5q0 -42 -30 -72t-72 -30zM281 1026v-1026h-152v1026h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cordinal",
    horizAdvX: 833,
    d: "M473 760q129 0 221 96l78 -86q-128 -125 -303 -125q-166 0 -280.5 116t-114.5 283q0 169 114.5 285.5t280.5 116.5q86 0 166.5 -32t140.5 -91l-80 -90q-95 98 -223 98q-115 0 -193.5 -82.5t-78.5 -204.5q0 -120 78.5 -202t193.5 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM684 1466h195l-254 -237h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM604 1313q78 0 132 45.5t77 132.5l107 -27q-28 -119 -111.5 -185.5t-204.5 -66.5q-123 0 -206 66.5t-109 185.5l106 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM774 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM424 1249q-43 0 -72.5 29t-29.5 72q0 41 29.5 69.5t72.5 28.5t71.5 -28.5t28.5 -69.5q0 -42 -29 -71.5t-71 -29.5zM782 1249q-43 0 -71.5 29t-28.5 72q0 41 28.5 69.5t71.5 28.5q44 0 72.5 -28t28.5 -70q0 -43 -29 -72t-72 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM520 1466l189 -237h-134l-251 237h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM901 1380v-108h-579v108h579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026q-112 -70 -164.5 -131t-52.5 -121q0 -51 31 -78.5t88 -27.5t98 28l31 -80q-67 -43 -152 -43q-91 0 -145.5 48.5t-54.5 128.5 q0 72 48 137.5t155 138.5h-31zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5t-109.5 -280.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM604 1192q-96 0 -162.5 66.5t-66.5 162.5q0 95 66 160.5t163 65.5q95 0 161 -66t66 -160q0 -95 -66.5 -162t-160.5 -67zM604 1276q59 0 99 42t40 103q0 59 -40.5 100.5t-98.5 41.5q-60 0 -100.5 -41t-40.5 -101q0 -63 40.5 -104t100.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.school",
    horizAdvX: 1208,
    d: "M930 0v109q-134 -125 -332 -125q-142 0 -260.5 69.5t-187 191.5t-68.5 269q0 223 149.5 375.5t368.5 152.5q188 0 328 -116v100h151v-1026h-149zM231 516q0 -169 110 -284t271 -115q96 0 179 37.5t137 105.5v508q-54 66 -137.5 103.5t-178.5 37.5q-162 0 -271.5 -112.5 t-109.5 -280.5zM375 1217l-107 20q46 205 193 205q37 0 81 -17.5t77 -39t72 -39t67 -17.5q35 0 56 26.5t36 90.5l104 -21q-43 -204 -192 -204q-46 0 -102 28t-108 56t-87 28q-37 0 -57.5 -26.5t-32.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g.alt",
    horizAdvX: 1085,
    d: "M113 662q0 161 123.5 273t300.5 112q156 0 274 -91q34 62 94 98t129 36q17 0 47 -5l6 -131q-32 4 -59 4q-99 0 -160 -55q93 -108 93 -241q0 -159 -122 -268t-302 -109q-67 0 -119 14q-47 -15 -73 -41.5t-26 -60.5q0 -77 125 -86l371 -19q128 -8 197 -63.5t69 -153.5 q0 -142 -151 -226.5t-406 -84.5q-224 0 -347.5 63.5t-123.5 179.5q0 68 53.5 124.5t151.5 93.5q-78 50 -78 141q0 53 36 98.5t99 73.5q-94 50 -148 135.5t-54 188.5zM817 662q0 110 -80.5 185t-199.5 75q-118 0 -198.5 -75t-80.5 -185q0 -107 80.5 -180.5t198.5 -73.5 t199 74t81 180zM197 -174q0 -71 84 -110.5t233 -39.5q190 0 303 48.5t113 130.5q0 94 -144 100l-344 18q-14 1 -36 4t-25 3q-89 -22 -136.5 -61.5t-47.5 -92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve.alt",
    horizAdvX: 1085,
    d: "M113 662q0 161 123.5 273t300.5 112q156 0 274 -91q34 62 94 98t129 36q17 0 47 -5l6 -131q-32 4 -59 4q-99 0 -160 -55q93 -108 93 -241q0 -159 -122 -268t-302 -109q-67 0 -119 14q-47 -15 -73 -41.5t-26 -60.5q0 -77 125 -86l371 -19q128 -8 197 -63.5t69 -153.5 q0 -142 -151 -226.5t-406 -84.5q-224 0 -347.5 63.5t-123.5 179.5q0 68 53.5 124.5t151.5 93.5q-78 50 -78 141q0 53 36 98.5t99 73.5q-94 50 -148 135.5t-54 188.5zM817 662q0 110 -80.5 185t-199.5 75q-118 0 -198.5 -75t-80.5 -185q0 -107 80.5 -180.5t198.5 -73.5 t199 74t81 180zM197 -174q0 -71 84 -110.5t233 -39.5q190 0 303 48.5t113 130.5q0 94 -144 100l-344 18q-14 1 -36 4t-25 3q-89 -22 -136.5 -61.5t-47.5 -92.5zM543 1313q78 0 132 45.5t77 132.5l106 -27q-28 -119 -111 -185.5t-204 -66.5q-123 0 -206.5 66.5t-109.5 185.5 l107 27q43 -178 209 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex.alt",
    horizAdvX: 1085,
    d: "M113 662q0 161 123.5 273t300.5 112q156 0 274 -91q34 62 94 98t129 36q17 0 47 -5l6 -131q-32 4 -59 4q-99 0 -160 -55q93 -108 93 -241q0 -159 -122 -268t-302 -109q-67 0 -119 14q-47 -15 -73 -41.5t-26 -60.5q0 -77 125 -86l371 -19q128 -8 197 -63.5t69 -153.5 q0 -142 -151 -226.5t-406 -84.5q-224 0 -347.5 63.5t-123.5 179.5q0 68 53.5 124.5t151.5 93.5q-78 50 -78 141q0 53 36 98.5t99 73.5q-94 50 -148 135.5t-54 188.5zM817 662q0 110 -80.5 185t-199.5 75q-118 0 -198.5 -75t-80.5 -185q0 -107 80.5 -180.5t198.5 -73.5 t199 74t81 180zM197 -174q0 -71 84 -110.5t233 -39.5q190 0 303 48.5t113 130.5q0 94 -144 100l-344 18q-14 1 -36 4t-25 3q-89 -22 -136.5 -61.5t-47.5 -92.5zM713 1221l-172 163l-170 -163h-123l213 247h164l213 -247h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent.alt",
    horizAdvX: 1085,
    d: "M113 662q0 161 123.5 273t300.5 112q156 0 274 -91q34 62 94 98t129 36q17 0 47 -5l6 -131q-32 4 -59 4q-99 0 -160 -55q93 -108 93 -241q0 -159 -122 -268t-302 -109q-67 0 -119 14q-47 -15 -73 -41.5t-26 -60.5q0 -77 125 -86l371 -19q128 -8 197 -63.5t69 -153.5 q0 -142 -151 -226.5t-406 -84.5q-224 0 -347.5 63.5t-123.5 179.5q0 68 53.5 124.5t151.5 93.5q-78 50 -78 141q0 53 36 98.5t99 73.5q-94 50 -148 135.5t-54 188.5zM817 662q0 110 -80.5 185t-199.5 75q-118 0 -198.5 -75t-80.5 -185q0 -107 80.5 -180.5t198.5 -73.5 t199 74t81 180zM197 -174q0 -71 84 -110.5t233 -39.5q190 0 303 48.5t113 130.5q0 94 -144 100l-344 18q-14 1 -36 4t-25 3q-89 -22 -136.5 -61.5t-47.5 -92.5zM614 1221h-151l123 366h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent.alt",
    horizAdvX: 1085,
    d: "M113 662q0 161 123.5 273t300.5 112q156 0 274 -91q34 62 94 98t129 36q17 0 47 -5l6 -131q-32 4 -59 4q-99 0 -160 -55q93 -108 93 -241q0 -159 -122 -268t-302 -109q-67 0 -119 14q-47 -15 -73 -41.5t-26 -60.5q0 -77 125 -86l371 -19q128 -8 197 -63.5t69 -153.5 q0 -142 -151 -226.5t-406 -84.5q-224 0 -347.5 63.5t-123.5 179.5q0 68 53.5 124.5t151.5 93.5q-78 50 -78 141q0 53 36 98.5t99 73.5q-94 50 -148 135.5t-54 188.5zM817 662q0 110 -80.5 185t-199.5 75q-118 0 -198.5 -75t-80.5 -185q0 -107 80.5 -180.5t198.5 -73.5 t199 74t81 180zM197 -174q0 -71 84 -110.5t233 -39.5q190 0 303 48.5t113 130.5q0 94 -144 100l-344 18q-14 1 -36 4t-25 3q-89 -22 -136.5 -61.5t-47.5 -92.5zM543 1233q-41 0 -71 29.5t-30 70.5t30 71t71 30q43 0 72.5 -30t29.5 -71t-29.5 -70.5t-72.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caronSlovak",
    horizAdvX: 952,
    d: "M416 1462h159l-57 -422h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00200326",
    horizAdvX: 468,
    d: "M147 -174h152l-123 -367h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "reversequoteleft",
    horizAdvX: 405,
    d: "M225 1473l117 -433h-119l-162 433h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "reversequotedblleft",
    horizAdvX: 681,
    d: "M225 1473l117 -433h-119l-162 433h164zM502 1473l119 -433h-119l-164 433h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.cap",
    horizAdvX: 405,
    d: "M203 815q43 0 73.5 -30.5t30.5 -73.5t-30.5 -74t-73.5 -31t-74 31t-31 74t31 73.5t74 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen.cap",
    horizAdvX: 915,
    d: "M100 776h715v-135h-715v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash.cap",
    horizAdvX: 1120,
    d: "M100 776h920v-135h-920v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash.cap",
    horizAdvX: 1427,
    d: "M100 776h1227v-135h-1227v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2015.cap",
    horizAdvX: 1939,
    d: "M100 776h1739v-135h-1739v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.cap",
    horizAdvX: 1597,
    d: "M731 381q-126 0 -209.5 88.5t-83.5 220.5q0 151 100.5 257t245.5 106q127 0 207 -80l10 53h115l-80 -393q-15 -73 15.5 -113.5t99.5 -40.5q107 0 179.5 99t72.5 245q0 153 -77 277.5t-211.5 195t-299.5 70.5q-173 0 -316.5 -87t-226 -238.5t-82.5 -335.5 q0 -180 82.5 -324.5t229 -225.5t329.5 -81q193 0 349 84l37 -84q-182 -92 -392 -92q-207 0 -375.5 93t-264 257.5t-95.5 367.5q0 159 56 299t152.5 240.5t231.5 158.5t289 58q190 0 346.5 -82.5t246 -227t89.5 -319.5q0 -189 -103.5 -313.5t-258.5 -124.5q-132 0 -191 84 q-106 -92 -217 -92zM551 698q0 -98 57 -159.5t148 -61.5q94 0 166 72q-7 48 4 94l43 217q-29 44 -78.5 69t-108.5 25q-95 0 -163 -75.5t-68 -180.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "7",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "4",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "2",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "X",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "8",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 393
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "?",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "&",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "@",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 225
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "&",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "x",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "X",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "7",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\\\\\\\\",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "?",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "/",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "V",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 242
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\\\\\\\",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "@",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\\\\\\\",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "X",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "V",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "at.cap",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "atilde.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "aring.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "aogonek.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "amacron.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "agrave.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "adieresis.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "acircumflex.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "abreve.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "aacute.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "a.school",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uFB02",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uFB01",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u021B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0167",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0165",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0163",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0151",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014F",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0123",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0122",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0121",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011F",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011C",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0117",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0115",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0113",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0111",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010F",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0109",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0108",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "t",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "f",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "j",
    k: -283
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "1",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "@",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "/",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "&",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "/",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "/",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "atilde.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "aring.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "aogonek.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "amacron.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "agrave.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "adieresis.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "acircumflex.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "abreve.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "aacute.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    g2: "a.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0151",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0123",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0121",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0119",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0117",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0115",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0113",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0111",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010D",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0109",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0107",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "z",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 229
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "guillemotright,guilsinglright",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "comma,period,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "asterisk,registered,degree,trademark",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 262
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 377
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,ellipsis",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "b,h,i,j,k,l,germandbls,iacute,thorn,hcircumflex,hbar,iogonek,ij,uni0137,lacute,uni013C,lcaron,ldot,lslash,idotaccent",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 336
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotright,guilsinglright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,ellipsis",
    k: 291
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "asterisk,registered,degree,trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "parenright,bracketright,braceright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 315
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,ellipsis",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "asterisk,registered,degree,trademark",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "three,five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "three,five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 254
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "three,five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "zero,six",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,ellipsis",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "comma,period,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "asterisk,registered,degree,trademark",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "guillemotleft,guilsinglleft",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "three,five",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "question",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 229
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 250
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "three,five",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "zero,six",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "guillemotright,guilsinglright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,ellipsis",
    k: 213
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "colon,semicolon",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "guillemotleft,guilsinglleft",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "parenright,bracketright,braceright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "zero,six",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 213
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 344
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "three,five",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "zero,six",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "asterisk,registered,degree,trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "J,Jcircumflex",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 262
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 270
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "guillemotright,guilsinglright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "comma,period,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "asterisk,registered,degree,trademark",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "guillemotleft,guilsinglleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "V",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "X",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "ampersand",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "at",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "backslash",
    k: 276
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "question",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "slash",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "v",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "x",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "comma,period,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "ampersand",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "at",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "question",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "guillemotright,guilsinglright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "asterisk,registered,degree,trademark",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "guillemotleft,guilsinglleft",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "V",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "ampersand",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "at",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "guillemotright,guilsinglright",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "comma,period,ellipsis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "asterisk,registered,degree,trademark",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "V",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "X",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "backslash",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "question",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "asterisk,registered,degree,trademark",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "V",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "X",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "ampersand",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "at",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "v",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "x",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "Dcroat",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "exclam",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 336
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 330
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 254
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "asterisk,registered,degree,trademark",
    k: 406
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "parenright,bracketright,braceright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 315
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "at",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 463
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "guillemotright,guilsinglright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "comma,period,ellipsis",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "asterisk,registered,degree,trademark",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "parenright,bracketright,braceright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "X",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "backslash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "question",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,copyright,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,at.cap",
    g2: "x",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "comma,period,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "asterisk,registered,degree,trademark",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "parenright,bracketright,braceright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "X",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "ampersand",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "at",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "comma,period,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "asterisk,registered,degree,trademark",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "guillemotleft,guilsinglleft",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "parenright,bracketright,braceright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "X",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "ampersand",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "at",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "backslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "question",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 262
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "J,Jcircumflex",
    k: 336
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "guillemotright,guilsinglright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "comma,period,ellipsis",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "asterisk,registered,degree,trademark",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "colon,semicolon",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "guillemotleft,guilsinglleft",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 242
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "parenright,bracketright,braceright",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ampersand",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "at",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "question",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "slash",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "guillemotright,guilsinglright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "slash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,ellipsis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "V",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 270
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "J,Jcircumflex",
    k: 414
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "comma,period,ellipsis",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "colon,semicolon",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "b,h,i,j,k,l,germandbls,iacute,thorn,hcircumflex,hbar,iogonek,ij,uni0137,lacute,uni013C,lcaron,ldot,lslash,idotaccent",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 250
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "V",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "X",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "ampersand",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "at",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "backslash",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "slash",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "v",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "x",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "J,Jcircumflex",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "comma,period,ellipsis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "X",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "ampersand",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "question",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "v",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "seven",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "three,five",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "V",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "x",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "seven",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "nine",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "one",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,hyphen,endash,emdash,uni2015,minus",
    g2: "two",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "three,five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "x",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "seven",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "one",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "eight",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "four",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "three,five",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "seven",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "nine",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "one",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "two",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "four",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "iacute,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "iacute,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    g2: "backslash",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "three,five",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "seven",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "nine",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "eight",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft,bracketleft,braceleft",
    g2: "four",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "J,Jcircumflex",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "three,five",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "zero,six",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "V",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "v",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "seven",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "nine",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "one",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "eight",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "four",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 201
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "J,Jcircumflex",
    k: 358
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,ellipsis",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "three,five",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "zero,six",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "V",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "X",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "v",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "seven",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "one",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "two",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "eight",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "four",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "J,Jcircumflex",
    k: 293
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "C,G,O,Q,copyright,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,at.cap",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "V",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "v",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "two",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "eight",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,degree,trademark",
    g2: "four",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "comma,period,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "asterisk,registered,degree,trademark",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "guillemotleft,guilsinglleft",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "three,five",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "ampersand",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "question",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "seven",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "nine",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "one",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "two",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five,six",
    g2: "eight",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "comma,period,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "asterisk,registered,degree,trademark",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "parenright,bracketright,braceright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "three,five",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "zero,six",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "backslash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "question",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "seven",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "nine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "one",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "two",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three,eight",
    g2: "eight",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "guillemotright,guilsinglright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "comma,period,ellipsis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "parenright,bracketright,braceright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "backslash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "question",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "seven",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "nine",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "one",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero,nine",
    g2: "two",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotright,guilsinglright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "comma,period,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "ampersand",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "guillemotright,guilsinglright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "comma,period,ellipsis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "asterisk,registered,degree,trademark",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "guillemotleft,guilsinglleft",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "ampersand",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "backslash",
    k: 238
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "question",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "slash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "comma,period,ellipsis",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "ampersand",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    g2: "x",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "guillemotright,guilsinglright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "guillemotleft,guilsinglleft",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "parenright,bracketright,braceright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "ampersand",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "at",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "backslash",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "question",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "slash",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "v",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137,kgreenlandic",
    g2: "x",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "guillemotright,guilsinglright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "asterisk,registered,degree,trademark",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "backslash",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "question",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hcircumflex,hbar,nacute,uni0146,ncaron,eng",
    g2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "comma,period,ellipsis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "asterisk,registered,degree,trademark",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "colon,semicolon",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "guillemotleft,guilsinglleft",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "parenright,bracketright,braceright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "ampersand",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "backslash",
    k: 221
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "question",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "slash",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut",
    g2: "x",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gcircumflex,gbreve,gdotaccent,uni0123,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    g2: "backslash",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gcircumflex,gbreve,gdotaccent,uni0123,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    g2: "question",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,u,ugrave,uacute,ucircumflex,udieresis,gcircumflex,gbreve,gdotaccent,uni0123,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    g2: "slash",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "guillemotright,guilsinglright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "comma,period,ellipsis",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "parenright,bracketright,braceright",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "ampersand",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "at",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "backslash",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "slash",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "v",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "comma,period,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "asterisk,registered,degree,trademark",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "ampersand",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "at",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "backslash",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "question",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "slash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls,sacute,scircumflex,uni015F,scaron,uni0219",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "backslash",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "question",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "v",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B",
    g2: "exclam",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "comma,period,ellipsis",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "asterisk,registered,degree,trademark",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "ampersand",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "at",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "backslash",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "question",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "slash",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "v",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "x",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,ellipsis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "asterisk,registered,degree,trademark",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "f,t,uni0163,tcaron,tbar,uni021B,fi,fl",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "colon,semicolon",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ampersand",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "at",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "question",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "v",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "plus,hyphen,endash,emdash,uni2015,minus",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "g.alt,gbreve.alt,gcircumflex.alt,gcommaaccent.alt,gdotaccent.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,d,e,g,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,a.school,aacute.school,abreve.school,acircumflex.school,adieresis.school,agrave.school,amacron.school,aogonek.school,aring.school,atilde.school",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "backslash",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "v",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "x",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,uni0145,Ncaron,Eng",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,uni0145,Ncaron,Eng",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,i,j,l,igrave,dcaron,dcroat,iogonek,ij,lacute,uni013C,lcaron,fi,fl,idotaccent",
    g2: "quoteleft,quoteright,quotedblleft,quotedblright",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,i,j,l,igrave,dcaron,dcroat,iogonek,ij,lacute,uni013C,lcaron,fi,fl,idotaccent",
    g2: "igrave,icircumflex,idieresis,itilde,imacron,ibreve,jcircumflex",
    k: -8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHatDisplayRegular);
export default __webpack_public_path__ + "static/media/RedHatDisplay-Regular.501bd41b53171aaadf54c5ebdc0921aa.svg";
export { ForwardRef as ReactComponent };